// // // // import React, { useState, useRef, useEffect, useCallback } from "react";

// // // // const C = {
// // // //   primary:      "#5E0E73",
// // // //   primaryLight: "#6E1A85",
// // // //   primaryDeep:  "#3A0847",
// // // //   gold:         "#C9A84C",
// // // //   goldLight:    "#E8D5A0",
// // // //   goldBright:   "#F5D87A",
// // // //   dark:         "#1A0030",
// // // //   dark2:        "#120020",
// // // // };

// // // // /*
// // // //   Replace src/ytId/thumb with your real content.
// // // //   src   → local video path e.g. "/assets/videos/t1.mp4" (preferred for autoplay)
// // // //   ytId  → YouTube ID (fallback — no autoplay on mobile)
// // // //   thumb → poster frame URL
// // // //   quote → pull-quote shown as overlay text
// // // // */
// // // // const TESTIMONIALS = [
// // // //   {
// // // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // // //     ytId:  null,
// // // //     thumb: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=1200&q=80",
// // // //     name:  "Aisha & Rahul",
// // // //     event: "Anniversary Night",
// // // //     loc:   "Banjara Hills",
// // // //     quote: "It was absolutely cinematic — every detail felt made just for us.",
// // // //     rating: 5,
// // // //   },
// // // //   {
// // // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // // //     ytId:  null,
// // // //     thumb: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80",
// // // //     name:  "Karan Mehta",
// // // //     event: "Birthday Surprise",
// // // //     loc:   "Jubilee Hills",
// // // //     quote: "She was completely speechless. The entire vibe was flawless.",
// // // //     rating: 5,
// // // //   },
// // // //   {
// // // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // // //     ytId:  null,
// // // //     thumb: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=1200&q=80",
// // // //     name:  "Rohit & Priya",
// // // //     event: "Love Proposal",
// // // //     loc:   "Kondapur",
// // // //     quote: "She said YES! The candles, the roses, the slideshow — perfect.",
// // // //     rating: 5,
// // // //   },
// // // //   {
// // // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // // //     ytId:  null,
// // // //     thumb: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1200&q=80",
// // // //     name:  "Sruthi Varma",
// // // //     event: "Bride To Be",
// // // //     loc:   "Madhapur",
// // // //     quote: "Every single detail was taken care of. We're already planning our next event!",
// // // //     rating: 5,
// // // //   },
// // // //   {
// // // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
// // // //     ytId:  null,
// // // //     thumb: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=1200&q=80",
// // // //     name:  "Divya Nair",
// // // //     event: "Mom To Be",
// // // //     loc:   "Gachibowli",
// // // //     quote: "The team went above and beyond. My sister was in happy tears!",
// // // //     rating: 5,
// // // //   },
// // // // ];

// // // // export default function VideoTestimonialsSpotlight() {
// // // //   const [activeIdx,  setActiveIdx]  = useState(0);
// // // //   const [playing,    setPlaying]    = useState(false);
// // // //   const [muted,      setMuted]      = useState(true);
// // // //   const [progress,   setProgress]   = useState(0);
// // // //   const [transitioning, setTransitioning] = useState(false);
// // // //   const videoRef = useRef(null);
// // // //   const autoRef  = useRef(null);

// // // //   const cur = TESTIMONIALS[activeIdx];

// // // //   /* ── reset video on index change ── */
// // // //   useEffect(() => {
// // // //     const vid = videoRef.current;
// // // //     if (!vid) return;
// // // //     vid.pause();
// // // //     vid.currentTime = 0;
// // // //     setPlaying(false);
// // // //     setProgress(0);
// // // //   }, [activeIdx]);

// // // //   /* ── progress tracking ── */
// // // //   useEffect(() => {
// // // //     const vid = videoRef.current;
// // // //     if (!vid) return;
// // // //     const onTime = () => {
// // // //       if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100);
// // // //     };
// // // //     const onEnd = () => { setPlaying(false); setProgress(0); };
// // // //     vid.addEventListener("timeupdate", onTime);
// // // //     vid.addEventListener("ended", onEnd);
// // // //     return () => { vid.removeEventListener("timeupdate", onTime); vid.removeEventListener("ended", onEnd); };
// // // //   }, [activeIdx]);

// // // //   /* ── mute sync ── */
// // // //   useEffect(() => {
// // // //     if (videoRef.current) videoRef.current.muted = muted;
// // // //   }, [muted]);

// // // //   const togglePlay = () => {
// // // //     const vid = videoRef.current;
// // // //     if (!vid) return;
// // // //     if (playing) { vid.pause(); setPlaying(false); }
// // // //     else { vid.muted = muted; vid.play().catch(() => {}); setPlaying(true); }
// // // //   };

// // // //   const goTo = useCallback((i) => {
// // // //     if (i === activeIdx || transitioning) return;
// // // //     setTransitioning(true);
// // // //     setTimeout(() => {
// // // //       setActiveIdx(i);
// // // //       setTransitioning(false);
// // // //     }, 320);
// // // //   }, [activeIdx, transitioning]);

// // // //   const goPrev = () => goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
// // // //   const goNext = () => goTo((activeIdx + 1) % TESTIMONIALS.length);

// // // //   /* ── auto-advance queue (only when not playing) ── */
// // // //   useEffect(() => {
// // // //     if (!playing) {
// // // //       autoRef.current = setInterval(() => {
// // // //         goTo((activeIdx + 1) % TESTIMONIALS.length);
// // // //       }, 5000);
// // // //     } else {
// // // //       clearInterval(autoRef.current);
// // // //     }
// // // //     return () => clearInterval(autoRef.current);
// // // //   }, [playing, activeIdx]);

// // // //   return (
// // // //     <>
// // // //       <style>{`
// // // //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// // // //         @keyframes vts-fadeUp   { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
// // // //         @keyframes vts-goldBg   { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
// // // //         @keyframes vts-shine    { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
// // // //         @keyframes vts-pulse    { 0%,100%{transform:scale(1);opacity:.5} 50%{transform:scale(1.15);opacity:.9} }
// // // //         @keyframes vts-spin     { to{transform:rotate(360deg)} }
// // // //         @keyframes vts-quoteIn  { from{opacity:0;transform:translateX(-16px)} to{opacity:1;transform:translateX(0)} }
// // // //         @keyframes vts-nameIn   { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
// // // //         @keyframes vts-fadeIn   { from{opacity:0} to{opacity:1} }

// // // //         .vts-sec {
// // // //           padding: 0;
// // // //           background: ${C.dark2};
// // // //           font-family: 'DM Sans', sans-serif;
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //         }

// // // //         /* ── top header strip ── */
// // // //         .vts-header {
// // // //           padding: 72px 60px 52px;
// // // //           display: flex;
// // // //           align-items: flex-end;
// // // //           justify-content: space-between;
// // // //           flex-wrap: wrap;
// // // //           gap: 20px;
// // // //           position: relative;
// // // //           z-index: 2;
// // // //         }
// // // //         .vts-header::after {
// // // //           content: '';
// // // //           position: absolute;
// // // //           bottom: 0; left: 60px; right: 60px;
// // // //           height: 1px;
// // // //           background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
// // // //         }

// // // //         .vts-eyebrow {
// // // //           display: flex; align-items: center; gap: 10px;
// // // //           font-size: 11px; font-weight: 700; letter-spacing: 3px;
// // // //           text-transform: uppercase; color: ${C.gold};
// // // //           margin-bottom: 14px;
// // // //         }
// // // //         .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }

// // // //         .vts-h {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: clamp(28px, 4vw, 46px);
// // // //           font-weight: 700; color: #fff;
// // // //           line-height: 1.1; margin: 0;
// // // //           letter-spacing: -.5px;
// // // //         }
// // // //         .vts-h em { font-style: italic; color: ${C.gold}; }

// // // //         .vts-counter {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: 14px; color: rgba(255,255,255,.3);
// // // //           flex-shrink: 0;
// // // //           align-self: flex-end;
// // // //         }
// // // //         .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

// // // //         /* ── main stage ── */
// // // //         .vts-stage {
// // // //           display: grid;
// // // //           grid-template-columns: 1fr 340px;
// // // //           min-height: 580px;
// // // //           position: relative;
// // // //         }

// // // //         /* ── featured video pane ── */
// // // //         .vts-feature {
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //           background: #000;
// // // //           cursor: pointer;
// // // //         }

// // // //         .vts-feature-bg {
// // // //           position: absolute; inset: 0;
// // // //           background-size: cover;
// // // //           background-position: center;
// // // //           transition: opacity .35s, transform .55s cubic-bezier(.25,1,.5,1);
// // // //         }
// // // //         .vts-feature-bg.fading { opacity: 0; transform: scale(1.04); }

// // // //         .vts-video {
// // // //           position: absolute; inset: 0;
// // // //           width: 100%; height: 100%;
// // // //           object-fit: cover;
// // // //           display: block;
// // // //         }

// // // //         /* cinematic top/bottom bars */
// // // //         .vts-cinema-bar {
// // // //           position: absolute; left: 0; right: 0;
// // // //           background: #000;
// // // //           height: 0;
// // // //           transition: height .4s ease;
// // // //           z-index: 3;
// // // //           pointer-events: none;
// // // //         }
// // // //         .vts-cinema-bar.top { top: 0; }
// // // //         .vts-cinema-bar.bot { bottom: 0; }
// // // //         .vts-feature.playing .vts-cinema-bar { height: 32px; }

// // // //         /* gradient overlay */
// // // //         .vts-feat-ovl {
// // // //           position: absolute; inset: 0;
// // // //           background:
// // // //             linear-gradient(to top, rgba(13,0,24,.95) 0%, rgba(13,0,24,.2) 45%, rgba(13,0,24,.05) 100%),
// // // //             linear-gradient(to right, rgba(13,0,24,.4) 0%, transparent 50%);
// // // //           z-index: 2;
// // // //           pointer-events: none;
// // // //           transition: opacity .3s;
// // // //         }

// // // //         /* progress bar */
// // // //         .vts-feat-prog {
// // // //           position: absolute;
// // // //           bottom: 0; left: 0; right: 0;
// // // //           height: 3px;
// // // //           background: rgba(255,255,255,.1);
// // // //           z-index: 6;
// // // //         }
// // // //         .vts-feat-prog-fill {
// // // //           height: 100%;
// // // //           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
// // // //           transition: width .1s linear;
// // // //           border-radius: 0 3px 3px 0;
// // // //         }

// // // //         /* big play/pause button */
// // // //         .vts-play-btn {
// // // //           position: absolute;
// // // //           top: 50%; left: 50%;
// // // //           transform: translate(-50%, -50%);
// // // //           z-index: 5;
// // // //           width: 80px; height: 80px;
// // // //           border-radius: 50%;
// // // //           background: rgba(255,255,255,.1);
// // // //           border: 2px solid rgba(255,255,255,.35);
// // // //           backdrop-filter: blur(16px);
// // // //           display: flex; align-items: center; justify-content: center;
// // // //           cursor: pointer;
// // // //           transition: all .3s cubic-bezier(.25,1,.5,1);
// // // //           box-shadow: 0 12px 40px rgba(0,0,0,.5);
// // // //         }
// // // //         .vts-play-btn:hover {
// // // //           background: ${C.gold};
// // // //           border-color: ${C.gold};
// // // //           transform: translate(-50%, -50%) scale(1.1);
// // // //           box-shadow: 0 16px 50px rgba(201,168,76,.5);
// // // //         }
// // // //         .vts-play-btn:hover svg { fill: ${C.dark}; }
// // // //         .vts-play-btn svg { fill: #fff; transition: fill .3s; }

// // // //         /* pulse ring behind play button */
// // // //         .vts-pulse-ring {
// // // //           position: absolute;
// // // //           top: 50%; left: 50%;
// // // //           transform: translate(-50%, -50%);
// // // //           width: 80px; height: 80px;
// // // //           border-radius: 50%;
// // // //           border: 1.5px solid rgba(201,168,76,.5);
// // // //           z-index: 4;
// // // //           animation: vts-pulse 2.5s ease-in-out infinite;
// // // //           pointer-events: none;
// // // //         }
// // // //         .vts-feature.playing .vts-pulse-ring { display: none; }

// // // //         /* bottom-left: quote + identity */
// // // //         .vts-feat-bottom {
// // // //           position: absolute;
// // // //           bottom: 36px; left: 40px; right: 60px;
// // // //           z-index: 5;
// // // //         }

// // // //         .vts-feat-quote {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: clamp(17px, 2vw, 22px);
// // // //           font-style: italic;
// // // //           font-weight: 600;
// // // //           color: #fff;
// // // //           line-height: 1.5;
// // // //           margin: 0 0 20px;
// // // //           max-width: 520px;
// // // //           text-shadow: 0 2px 12px rgba(0,0,0,.5);
// // // //           animation: vts-quoteIn .5s cubic-bezier(.25,1,.5,1) both;
// // // //         }
// // // //         .vts-feat-quote::before {
// // // //           content: '"';
// // // //           font-size: 2em;
// // // //           line-height: 0;
// // // //           vertical-align: -.4em;
// // // //           color: ${C.gold};
// // // //           margin-right: 4px;
// // // //           opacity: .7;
// // // //         }

// // // //         .vts-feat-identity {
// // // //           display: flex; align-items: center; gap: 14px;
// // // //           animation: vts-nameIn .5s cubic-bezier(.25,1,.5,1) .1s both;
// // // //         }
// // // //         .vts-feat-avatar {
// // // //           width: 50px; height: 50px; border-radius: 50%;
// // // //           border: 2px solid rgba(201,168,76,.55);
// // // //           background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
// // // //           display: flex; align-items: center; justify-content: center;
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: 17px; font-weight: 700; color: ${C.goldLight};
// // // //           flex-shrink: 0;
// // // //           box-shadow: 0 0 0 4px rgba(201,168,76,.12);
// // // //         }
// // // //         .vts-feat-name {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: 17px; font-weight: 700; color: #fff;
// // // //           margin-bottom: 3px;
// // // //         }
// // // //         .vts-feat-meta {
// // // //           display: flex; align-items: center; gap: 8px;
// // // //           font-size: 12px; color: rgba(255,255,255,.5);
// // // //         }
// // // //         .vts-feat-pill {
// // // //           background: rgba(201,168,76,.2);
// // // //           border: 1px solid rgba(201,168,76,.4);
// // // //           color: ${C.goldLight};
// // // //           font-size: 9px; font-weight: 800;
// // // //           letter-spacing: 1.5px; text-transform: uppercase;
// // // //           padding: 3px 9px; border-radius: 50px;
// // // //         }

// // // //         /* top-right controls */
// // // //         .vts-feat-controls {
// // // //           position: absolute;
// // // //           top: 20px; right: 20px;
// // // //           z-index: 5;
// // // //           display: flex; gap: 8px;
// // // //         }
// // // //         .vts-ctrl-btn {
// // // //           width: 36px; height: 36px; border-radius: 50%;
// // // //           background: rgba(0,0,0,.5);
// // // //           border: 1px solid rgba(255,255,255,.15);
// // // //           color: #fff; font-size: 14px;
// // // //           display: flex; align-items: center; justify-content: center;
// // // //           cursor: pointer;
// // // //           backdrop-filter: blur(10px);
// // // //           transition: all .2s;
// // // //         }
// // // //         .vts-ctrl-btn:hover { background: rgba(201,168,76,.3); border-color: ${C.gold}; }

// // // //         /* stars */
// // // //         .vts-stars { display: flex; gap: 3px; margin-bottom: 12px; }
// // // //         .vts-star  { font-size: 14px; }

// // // //         /* ── right sidebar queue ── */
// // // //         .vts-queue {
// // // //           background: rgba(255,255,255,.025);
// // // //           border-left: 1px solid rgba(255,255,255,.06);
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           overflow: hidden;
// // // //         }

// // // //         .vts-queue-header {
// // // //           padding: 24px 24px 18px;
// // // //           border-bottom: 1px solid rgba(255,255,255,.06);
// // // //           flex-shrink: 0;
// // // //         }
// // // //         .vts-queue-title {
// // // //           font-size: 11px; font-weight: 700; letter-spacing: 2px;
// // // //           text-transform: uppercase; color: rgba(255,255,255,.3);
// // // //         }

// // // //         .vts-queue-list {
// // // //           flex: 1;
// // // //           overflow-y: auto;
// // // //           padding: 12px 0;
// // // //           scrollbar-width: thin;
// // // //           scrollbar-color: rgba(201,168,76,.2) transparent;
// // // //         }
// // // //         .vts-queue-list::-webkit-scrollbar { width: 4px; }
// // // //         .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

// // // //         .vts-q-item {
// // // //           display: flex; align-items: center; gap: 14px;
// // // //           padding: 12px 20px;
// // // //           cursor: pointer;
// // // //           transition: all .25s;
// // // //           position: relative;
// // // //           border-left: 3px solid transparent;
// // // //         }
// // // //         .vts-q-item:hover { background: rgba(255,255,255,.04); }
// // // //         .vts-q-item.active {
// // // //           background: rgba(201,168,76,.07);
// // // //           border-left-color: ${C.gold};
// // // //         }

// // // //         .vts-q-thumb {
// // // //           width: 72px; height: 54px;
// // // //           border-radius: 10px;
// // // //           overflow: hidden;
// // // //           flex-shrink: 0;
// // // //           position: relative;
// // // //           border: 1px solid rgba(255,255,255,.07);
// // // //           transition: border-color .25s;
// // // //         }
// // // //         .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
// // // //         .vts-q-thumb img {
// // // //           width: 100%; height: 100%;
// // // //           object-fit: cover; display: block;
// // // //           transition: transform .4s;
// // // //           filter: brightness(.8);
// // // //         }
// // // //         .vts-q-item:hover .vts-q-thumb img { transform: scale(1.06); filter: brightness(1); }
// // // //         .vts-q-item.active .vts-q-thumb img { filter: brightness(.9); }

// // // //         /* playing indicator */
// // // //         .vts-q-playing {
// // // //           position: absolute; inset: 0;
// // // //           background: rgba(13,0,24,.6);
// // // //           display: flex; align-items: center; justify-content: center;
// // // //           border-radius: 9px;
// // // //         }
// // // //         .vts-q-eq {
// // // //           display: flex; align-items: flex-end; gap: 2px; height: 18px;
// // // //         }
// // // //         .vts-q-bar {
// // // //           width: 3px; background: ${C.gold};
// // // //           border-radius: 2px;
// // // //           animation: vts-eqBar 1s ease-in-out infinite;
// // // //         }
// // // //         .vts-q-bar:nth-child(1) { animation-delay: 0s; }
// // // //         .vts-q-bar:nth-child(2) { animation-delay: .15s; }
// // // //         .vts-q-bar:nth-child(3) { animation-delay: .3s; }
// // // //         @keyframes vts-eqBar {
// // // //           0%,100% { height: 6px; }
// // // //           50%      { height: 18px; }
// // // //         }

// // // //         .vts-q-info { flex: 1; min-width: 0; }
// // // //         .vts-q-name {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: 13px; font-weight: 700; color: #fff;
// // // //           white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
// // // //           margin-bottom: 3px;
// // // //           transition: color .2s;
// // // //         }
// // // //         .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
// // // //         .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }

// // // //         .vts-q-num {
// // // //           font-size: 11px; color: rgba(255,255,255,.2);
// // // //           flex-shrink: 0; font-family: 'Playfair Display', serif;
// // // //         }
// // // //         .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

// // // //         /* prev/next nav at bottom of sidebar */
// // // //         .vts-queue-nav {
// // // //           padding: 16px 20px;
// // // //           border-top: 1px solid rgba(255,255,255,.06);
// // // //           display: flex; align-items: center; justify-content: space-between;
// // // //           flex-shrink: 0;
// // // //         }
// // // //         .vts-nav-label {
// // // //           font-size: 11px; color: rgba(255,255,255,.25);
// // // //           letter-spacing: 1px; text-transform: uppercase;
// // // //         }
// // // //         .vts-nav-arrows { display: flex; gap: 8px; }
// // // //         .vts-nav-btn {
// // // //           width: 38px; height: 38px; border-radius: 50%;
// // // //           background: rgba(255,255,255,.05);
// // // //           border: 1px solid rgba(255,255,255,.1);
// // // //           color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
// // // //           display: flex; align-items: center; justify-content: center;
// // // //           cursor: pointer; transition: all .25s;
// // // //         }
// // // //         .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

// // // //         /* ── bottom strip ── */
// // // //         .vts-strip {
// // // //           padding: 28px 60px 48px;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: space-between;
// // // //           gap: 20px;
// // // //           flex-wrap: wrap;
// // // //           border-top: 1px solid rgba(255,255,255,.05);
// // // //           position: relative;
// // // //           z-index: 2;
// // // //         }

// // // //         .vts-strip-ratings {
// // // //           display: flex; align-items: center; gap: 28px; flex-wrap: wrap;
// // // //         }
// // // //         .vts-rating-item { text-align: center; }
// // // //         .vts-rating-num {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: 22px; font-weight: 700; color: ${C.gold};
// // // //           line-height: 1;
// // // //         }
// // // //         .vts-rating-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
// // // //         .vts-rating-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

// // // //         .vts-btn-gold {
// // // //           position: relative; overflow: hidden;
// // // //           background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
// // // //           background-size: 200% 200%;
// // // //           animation: vts-goldBg 3s ease infinite;
// // // //           color: ${C.dark}; border: none;
// // // //           border-radius: 50px; padding: 13px 30px;
// // // //           font-weight: 800; font-size: 14px;
// // // //           cursor: pointer;
// // // //           box-shadow: 0 6px 24px rgba(201,168,76,.4);
// // // //           display: inline-flex; align-items: center; gap: 8px;
// // // //           font-family: 'DM Sans', sans-serif;
// // // //           transition: transform .3s, box-shadow .3s;
// // // //           text-decoration: none; flex-shrink: 0;
// // // //         }
// // // //         .vts-btn-gold::before {
// // // //           content: '';
// // // //           position: absolute; top: 0; left: -100%;
// // // //           width: 55%; height: 100%;
// // // //           background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
// // // //           animation: vts-shine 3s ease infinite;
// // // //         }
// // // //         .vts-btn-gold:hover {
// // // //           transform: translateY(-2px);
// // // //           box-shadow: 0 12px 36px rgba(201,168,76,.55);
// // // //           color: ${C.dark};
// // // //         }

// // // //         /* ── transition overlay ── */
// // // //         .vts-transition-overlay {
// // // //           position: absolute; inset: 0;
// // // //           background: ${C.dark2};
// // // //           z-index: 10;
// // // //           opacity: 0;
// // // //           pointer-events: none;
// // // //           transition: opacity .3s;
// // // //         }
// // // //         .vts-transition-overlay.show { opacity: 1; pointer-events: all; }

// // // //         /* ── responsive ── */
// // // //         @media (max-width: 1024px) {
// // // //           .vts-stage { grid-template-columns: 1fr 280px; }
// // // //           .vts-header { padding: 52px 32px 40px; }
// // // //           .vts-strip  { padding: 24px 32px 40px; }
// // // //           .vts-feat-bottom { left: 28px; right: 28px; bottom: 28px; }
// // // //         }
// // // //         @media (max-width: 768px) {
// // // //           .vts-stage { grid-template-columns: 1fr; grid-template-rows: 420px auto; }
// // // //           .vts-queue {
// // // //             border-left: none;
// // // //             border-top: 1px solid rgba(255,255,255,.06);
// // // //             max-height: 260px;
// // // //           }
// // // //           .vts-queue-list { display: flex; flex-direction: row; overflow-y: hidden; overflow-x: auto; padding: 12px; gap: 10px; }
// // // //           .vts-q-item { flex-direction: column; align-items: center; text-align: center; min-width: 110px; border-left: none; border-bottom: 3px solid transparent; padding: 10px; border-radius: 12px; }
// // // //           .vts-q-item.active { background: rgba(201,168,76,.07); border-bottom-color: ${C.gold}; border-left: none; }
// // // //           .vts-q-thumb { width: 100%; height: 72px; }
// // // //           .vts-q-num { display: none; }
// // // //           .vts-header { padding: 40px 20px 32px; }
// // // //           .vts-strip  { padding: 20px 20px 36px; flex-direction: column; align-items: flex-start; }
// // // //           .vts-feat-bottom { left: 20px; right: 20px; bottom: 20px; }
// // // //           .vts-feat-quote { font-size: 16px; }
// // // //           .vts-play-btn { width: 66px; height: 66px; }
// // // //         }
// // // //         @media (max-width: 480px) {
// // // //           .vts-h { font-size: clamp(24px, 7vw, 32px); }
// // // //           .vts-strip-ratings { gap: 16px; }
// // // //         }
// // // //       `}</style>

// // // //       <section className="vts-sec" id="video-testimonials">

// // // //         {/* ── Header ── */}
// // // //         <div className="vts-header">
// // // //           <div>
// // // //             <div className="vts-eyebrow">
// // // //               <div className="vts-eyebrow-line" />
// // // //               Customer Stories
// // // //               <div className="vts-eyebrow-line" />
// // // //             </div>
// // // //             <h2 className="vts-h">
// // // //               Real People,<br /><em>Real Celebrations</em>
// // // //             </h2>
// // // //           </div>
// // // //           <div className="vts-counter">
// // // //             <span>{String(activeIdx + 1).padStart(2, "0")}</span>
// // // //             {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
// // // //           </div>
// // // //         </div>

// // // //         {/* ── Stage ── */}
// // // //         <div className="vts-stage">

// // // //           {/* transition overlay */}
// // // //           <div className={`vts-transition-overlay${transitioning ? " show" : ""}`} />

// // // //           {/* ── Featured Video ── */}
// // // //           <div
// // // //             className={`vts-feature${playing ? " playing" : ""}`}
// // // //             onClick={togglePlay}
// // // //           >
// // // //             {/* cinematic bars */}
// // // //             <div className="vts-cinema-bar top" />
// // // //             <div className="vts-cinema-bar bot" />

// // // //             {/* poster */}
// // // //             <div
// // // //               className={`vts-feature-bg${transitioning ? " fading" : ""}`}
// // // //               style={{ backgroundImage:`url(${cur.thumb})` }}
// // // //             />

// // // //             {/* video */}
// // // //             {cur.src && (
// // // //               <video
// // // //                 key={activeIdx}
// // // //                 ref={videoRef}
// // // //                 className="vts-video"
// // // //                 src={cur.src}
// // // //                 muted={muted}
// // // //                 playsInline
// // // //                 preload="metadata"
// // // //                 style={{ opacity: playing ? 1 : 0, transition:"opacity .3s" }}
// // // //               />
// // // //             )}

// // // //             <div className="vts-feat-ovl" style={{ opacity: playing ? .6 : 1 }} />

// // // //             {/* progress */}
// // // //             {playing && (
// // // //               <div className="vts-feat-prog">
// // // //                 <div className="vts-feat-prog-fill" style={{ width:`${progress}%` }} />
// // // //               </div>
// // // //             )}

// // // //             {/* controls top-right */}
// // // //             <div className="vts-feat-controls" onClick={e => e.stopPropagation()}>
// // // //               <button
// // // //                 className="vts-ctrl-btn"
// // // //                 onClick={() => setMuted(m => !m)}
// // // //                 aria-label={muted ? "Unmute" : "Mute"}
// // // //               >
// // // //                 {muted ? "🔇" : "🔊"}
// // // //               </button>
// // // //             </div>

// // // //             {/* play/pause */}
// // // //             {!playing && <div className="vts-pulse-ring" />}
// // // //             <button
// // // //               className="vts-play-btn"
// // // //               onClick={e => { e.stopPropagation(); togglePlay(); }}
// // // //               aria-label={playing ? "Pause" : "Play"}
// // // //             >
// // // //               {playing
// // // //                 ? <svg width="22" height="22" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>
// // // //                 : <svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
// // // //               }
// // // //             </button>

// // // //             {/* bottom info */}
// // // //             <div className="vts-feat-bottom" key={activeIdx}>
// // // //               <div className="vts-stars">
// // // //                 {[1,2,3,4,5].map(n => (
// // // //                   <span key={n} className="vts-star" style={{ color:n<=cur.rating?C.gold:"rgba(201,168,76,.2)" }}>★</span>
// // // //                 ))}
// // // //               </div>
// // // //               <p className="vts-feat-quote">{cur.quote}</p>
// // // //               <div className="vts-feat-identity">
// // // //                 <div className="vts-feat-avatar">
// // // //                   {cur.name.split(" ").map(w => w[0]).slice(0,2).join("")}
// // // //                 </div>
// // // //                 <div>
// // // //                   <div className="vts-feat-name">{cur.name}</div>
// // // //                   <div className="vts-feat-meta">
// // // //                     <span className="vts-feat-pill">{cur.event}</span>
// // // //                     <span>📍 {cur.loc}</span>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           </div>

// // // //           {/* ── Queue Sidebar ── */}
// // // //           <div className="vts-queue">
// // // //             <div className="vts-queue-header">
// // // //               <div className="vts-queue-title">Up Next</div>
// // // //             </div>

// // // //             <div className="vts-queue-list">
// // // //               {TESTIMONIALS.map((t, i) => (
// // // //                 <div
// // // //                   key={i}
// // // //                   className={`vts-q-item${i === activeIdx ? " active" : ""}`}
// // // //                   onClick={() => goTo(i)}
// // // //                 >
// // // //                   <div className="vts-q-thumb">
// // // //                     <img src={t.thumb} alt={t.name} />
// // // //                     {i === activeIdx && playing && (
// // // //                       <div className="vts-q-playing">
// // // //                         <div className="vts-q-eq">
// // // //                           <div className="vts-q-bar" />
// // // //                           <div className="vts-q-bar" />
// // // //                           <div className="vts-q-bar" />
// // // //                         </div>
// // // //                       </div>
// // // //                     )}
// // // //                   </div>
// // // //                   <div className="vts-q-info">
// // // //                     <div className="vts-q-name">{t.name}</div>
// // // //                     <div className="vts-q-event">{t.event} · {t.loc}</div>
// // // //                   </div>
// // // //                   <div className="vts-q-num">
// // // //                     {String(i + 1).padStart(2, "0")}
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>

// // // //             <div className="vts-queue-nav">
// // // //               <span className="vts-nav-label">Navigate</span>
// // // //               <div className="vts-nav-arrows">
// // // //                 <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
// // // //                 <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
// // // //               </div>
// // // //             </div>
// // // //           </div>

// // // //         </div>

// // // //         {/* ── Bottom strip ── */}
// // // //         <div className="vts-strip">
// // // //           <div className="vts-strip-ratings">
// // // //             {[
// // // //               { num:"4.9★", label:"Google" },
// // // //               null,
// // // //               { num:"4.8★", label:"Facebook" },
// // // //               null,
// // // //               { num:"500+", label:"Happy Guests" },
// // // //               null,
// // // //               { num:"98%",  label:"Would Return" },
// // // //             ].map((item, i) =>
// // // //               item === null
// // // //                 ? <div key={i} className="vts-rating-sep" />
// // // //                 : (
// // // //                   <div key={i} className="vts-rating-item">
// // // //                     <div className="vts-rating-num">{item.num}</div>
// // // //                     <div className="vts-rating-label">{item.label}</div>
// // // //                   </div>
// // // //                 )
// // // //             )}
// // // //           </div>
// // // //           <a href="/locations" className="vts-btn-gold">
// // // //             🎉 Book Your Celebration
// // // //           </a>
// // // //         </div>

// // // //       </section>
// // // //     </>
// // // //   );
// // // // }


// // // import React, { useState, useRef, useEffect, useCallback } from "react";

// // // const C = {
// // //   primary:      "#5E0E73",
// // //   primaryLight: "#6E1A85",
// // //   primaryDeep:  "#3A0847",
// // //   gold:         "#C9A84C",
// // //   goldLight:    "#E8D5A0",
// // //   goldBright:   "#F5D87A",
// // //   dark:         "#1A0030",
// // //   dark2:        "#120020",
// // // };

// // // const TESTIMONIALS = [
// // //   {
// // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
// // //     name:  "Aisha & Rahul",
// // //     event: "Anniversary Night",
// // //     loc:   "Banjara Hills",
// // //     quote: "It was absolutely cinematic — every detail felt made just for us.",
// // //     rating: 5,
// // //   },
// // //   {
// // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
// // //     name:  "Karan Mehta",
// // //     event: "Birthday Surprise",
// // //     loc:   "Jubilee Hills",
// // //     quote: "She was completely speechless. The entire vibe was flawless.",
// // //     rating: 5,
// // //   },
// // //   {
// // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
// // //     name:  "Rohit & Priya",
// // //     event: "Love Proposal",
// // //     loc:   "Kondapur",
// // //     quote: "She said YES! The candles, the roses, the slideshow — perfect.",
// // //     rating: 5,
// // //   },
// // //   {
// // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
// // //     name:  "Sruthi Varma",
// // //     event: "Bride To Be",
// // //     loc:   "Madhapur",
// // //     quote: "Every single detail was taken care of. We're already planning our next event!",
// // //     rating: 5,
// // //   },
// // //   {
// // //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
// // //     name:  "Divya Nair",
// // //     event: "Mom To Be",
// // //     loc:   "Gachibowli",
// // //     quote: "The team went above and beyond. My sister was in happy tears!",
// // //     rating: 5,
// // //   },
// // // ];

// // // export default function VideoTestimonialsSpotlight() {
// // //   const [activeIdx,     setActiveIdx]     = useState(0);
// // //   const [playing,       setPlaying]       = useState(false);
// // //   const [muted,         setMuted]         = useState(true);
// // //   const [progress,      setProgress]      = useState(0);
// // //   const [transitioning, setTransitioning] = useState(false);
// // //   const [showControls,  setShowControls]  = useState(false);

// // //   const videoRef   = useRef(null);
// // //   const sectionRef = useRef(null);
// // //   const autoRef    = useRef(null);
// // //   const ctrlTimer  = useRef(null);

// // //   const cur = TESTIMONIALS[activeIdx];

// // //   /* stop when scrolled out of view */
// // //   useEffect(() => {
// // //     const el = sectionRef.current;
// // //     if (!el) return;
// // //     const obs = new IntersectionObserver(
// // //       ([entry]) => {
// // //         if (!entry.isIntersecting) {
// // //           videoRef.current?.pause();
// // //           setPlaying(false);
// // //         }
// // //       },
// // //       { threshold: 0.25 }
// // //     );
// // //     obs.observe(el);
// // //     return () => obs.disconnect();
// // //   }, []);

// // //   /* reset on index change */
// // //   useEffect(() => {
// // //     const vid = videoRef.current;
// // //     if (!vid) return;
// // //     vid.pause();
// // //     vid.currentTime = 0;
// // //     setPlaying(false);
// // //     setProgress(0);
// // //   }, [activeIdx]);

// // //   /* progress + ended */
// // //   useEffect(() => {
// // //     const vid = videoRef.current;
// // //     if (!vid) return;
// // //     const onTime = () => {
// // //       if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100);
// // //     };
// // //     const onEnd = () => { setPlaying(false); setProgress(0); };
// // //     vid.addEventListener("timeupdate", onTime);
// // //     vid.addEventListener("ended", onEnd);
// // //     return () => {
// // //       vid.removeEventListener("timeupdate", onTime);
// // //       vid.removeEventListener("ended", onEnd);
// // //     };
// // //   }, [activeIdx]);

// // //   /* mute sync */
// // //   useEffect(() => {
// // //     if (videoRef.current) videoRef.current.muted = muted;
// // //   }, [muted]);

// // //   const showCtrl = () => {
// // //     setShowControls(true);
// // //     clearTimeout(ctrlTimer.current);
// // //     ctrlTimer.current = setTimeout(() => setShowControls(false), 2500);
// // //   };

// // //   /* cursor enters reel — autoplay */
// // //   const handleMouseEnter = () => {
// // //     showCtrl();
// // //     const vid = videoRef.current;
// // //     if (vid && !playing) {
// // //       vid.muted = muted;
// // //       vid.play().then(() => setPlaying(true)).catch(() => {});
// // //     }
// // //   };

// // //   /* cursor leaves reel — stop */
// // //   const handleMouseLeave = () => {
// // //     setShowControls(false);
// // //     clearTimeout(ctrlTimer.current);
// // //     if (videoRef.current && playing) {
// // //       videoRef.current.pause();
// // //       setPlaying(false);
// // //     }
// // //   };

// // //   const handleMouseMove = () => showCtrl();

// // //   /* touch: tap to play/pause */
// // //   const handleTouchStart = (e) => {
// // //     e.preventDefault();
// // //     showCtrl();
// // //     const vid = videoRef.current;
// // //     if (!vid) return;
// // //     if (playing) { vid.pause(); setPlaying(false); }
// // //     else { vid.muted = muted; vid.play().then(() => setPlaying(true)).catch(() => {}); }
// // //   };

// // //   const togglePlay = (e) => {
// // //     e.stopPropagation();
// // //     const vid = videoRef.current;
// // //     if (!vid) return;
// // //     if (playing) { vid.pause(); setPlaying(false); }
// // //     else { vid.muted = muted; vid.play().then(() => setPlaying(true)).catch(() => {}); }
// // //   };

// // //   const goTo = useCallback((i) => {
// // //     if (i === activeIdx || transitioning) return;
// // //     setTransitioning(true);
// // //     setTimeout(() => { setActiveIdx(i); setTransitioning(false); }, 300);
// // //   }, [activeIdx, transitioning]);

// // //   const goPrev = () => goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
// // //   const goNext = () => goTo((activeIdx + 1) % TESTIMONIALS.length);

// // //   /* auto-advance only when not playing */
// // //   useEffect(() => {
// // //     if (!playing) {
// // //       autoRef.current = setInterval(() => {
// // //         setActiveIdx(i => (i + 1) % TESTIMONIALS.length);
// // //       }, 5000);
// // //     } else {
// // //       clearInterval(autoRef.current);
// // //     }
// // //     return () => clearInterval(autoRef.current);
// // //   }, [playing]);

// // //   return (
// // //     <>
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// // //         @keyframes vts-goldBg  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
// // //         @keyframes vts-shine   { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
// // //         @keyframes vts-pulse   { 0%,100%{transform:scale(1);opacity:.45} 50%{transform:scale(1.2);opacity:.85} }
// // //         @keyframes vts-quoteIn { from{opacity:0;transform:translateX(-14px)} to{opacity:1;transform:translateX(0)} }
// // //         @keyframes vts-nameIn  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
// // //         @keyframes vts-eqBar   { 0%,100%{height:5px} 50%{height:18px} }
// // //         @keyframes vts-ctrlIn  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

// // //         .vts-sec {
// // //           background: ${C.dark2};
// // //           font-family: 'DM Sans', sans-serif;
// // //           position: relative; overflow: hidden;
// // //         }
// // //         .vts-sec::before {
// // //           content: ''; position: absolute; inset: 0;
// // //           background:
// // //             radial-gradient(ellipse 65% 50% at 20% 10%, rgba(94,14,115,.28) 0%, transparent 65%),
// // //             radial-gradient(ellipse 50% 40% at 80% 90%, rgba(201,168,76,.08) 0%, transparent 65%);
// // //           pointer-events: none; z-index: 0;
// // //         }
// // //         .vts-sec::after {
// // //           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
// // //           width: 180px; height: 2px;
// // //           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
// // //         }

// // //         /* header */
// // //         .vts-header {
// // //           padding: 72px 60px 52px;
// // //           display: flex; align-items: flex-end;
// // //           justify-content: space-between; flex-wrap: wrap; gap: 20px;
// // //           position: relative; z-index: 2;
// // //         }
// // //         .vts-header::after {
// // //           content: ''; position: absolute; bottom: 0; left: 60px; right: 60px;
// // //           height: 1px;
// // //           background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
// // //         }
// // //         .vts-eyebrow {
// // //           display: flex; align-items: center; gap: 10px;
// // //           font-size: 11px; font-weight: 700; letter-spacing: 3px;
// // //           text-transform: uppercase; color: ${C.gold}; margin-bottom: 14px;
// // //         }
// // //         .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }
// // //         .vts-h {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: clamp(28px, 4vw, 46px);
// // //           font-weight: 700; color: #fff; line-height: 1.1; margin: 0;
// // //         }
// // //         .vts-h em { font-style: italic; color: ${C.gold}; }
// // //         .vts-counter {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 14px; color: rgba(255,255,255,.3); flex-shrink: 0; align-self: flex-end;
// // //         }
// // //         .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

// // //         /* stage */
// // //         .vts-stage {
// // //           display: grid; grid-template-columns: 1fr 340px;
// // //           min-height: 580px; position: relative; z-index: 1;
// // //         }

// // //         /* reel pane */
// // //         .vts-reel-pane {
// // //           position: relative;
// // //           display: flex; align-items: center; justify-content: center;
// // //           padding: 40px 0 40px 60px;
// // //           overflow: hidden;
// // //         }

// // //         /* ambient glow sphere */
// // //         .vts-glow-sphere {
// // //           position: absolute;
// // //           width: 420px; height: 420px; border-radius: 50%;
// // //           background: radial-gradient(circle, rgba(94,14,115,.22) 0%, transparent 70%);
// // //           top: 50%; left: 45%; transform: translate(-50%, -50%);
// // //           pointer-events: none; z-index: 0;
// // //           transition: background .5s;
// // //         }
// // //         .vts-glow-sphere.playing-glow {
// // //           background: radial-gradient(circle, rgba(201,168,76,.1) 0%, rgba(94,14,115,.15) 50%, transparent 70%);
// // //         }

// // //         /* reel container — 9:16 portrait */
// // //         .vts-reel {
// // //           position: relative;
// // //           width: min(300px, 82%);
// // //           aspect-ratio: 9 / 16;
// // //           border-radius: 32px;
// // //           overflow: hidden;
// // //           background: #000;
// // //           border: 2px solid rgba(255,255,255,.1);
// // //           box-shadow:
// // //             0 40px 100px rgba(0,0,0,.7),
// // //             0 0 0 1px rgba(255,255,255,.04),
// // //             inset 0 1px 0 rgba(255,255,255,.08);
// // //           cursor: pointer;
// // //           transition: border-color .35s, box-shadow .4s;
// // //           z-index: 1;
// // //           flex-shrink: 0;
// // //           -webkit-tap-highlight-color: transparent;
// // //           user-select: none;
// // //         }
// // //         .vts-reel:hover,
// // //         .vts-reel.playing {
// // //           border-color: rgba(201,168,76,.5);
// // //           box-shadow:
// // //             0 50px 120px rgba(0,0,0,.75),
// // //             0 0 60px rgba(201,168,76,.14),
// // //             0 0 0 1px rgba(255,255,255,.06),
// // //             inset 0 1px 0 rgba(255,255,255,.1);
// // //         }

// // //         /* notch */
// // //         .vts-notch {
// // //           position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
// // //           width: 80px; height: 5px;
// // //           background: rgba(255,255,255,.1); border-radius: 3px;
// // //           z-index: 8; pointer-events: none;
// // //         }

// // //         /* progress bar */
// // //         .vts-prog {
// // //           position: absolute; top: 0; left: 0; right: 0;
// // //           height: 3px; background: rgba(255,255,255,.08); z-index: 6;
// // //         }
// // //         .vts-prog-fill {
// // //           height: 100%;
// // //           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
// // //           border-radius: 0 2px 2px 0;
// // //           transition: width .1s linear;
// // //         }

// // //         /* video */
// // //         .vts-video {
// // //           position: absolute; inset: 0;
// // //           width: 100%; height: 100%;
// // //           object-fit: cover; display: block;
// // //         }

// // //         /* gradient overlay */
// // //         .vts-ovl {
// // //           position: absolute; inset: 0;
// // //           background:
// // //             linear-gradient(to top,  rgba(13,0,24,.96) 0%, rgba(13,0,24,.22) 45%, transparent 100%),
// // //             linear-gradient(to bottom, rgba(13,0,24,.5) 0%, transparent 25%);
// // //           pointer-events: none; z-index: 2;
// // //         }

// // //         /* idle pulse ring */
// // //         .vts-pulse-ring {
// // //           position: absolute; top: 50%; left: 50%;
// // //           transform: translate(-50%, -50%);
// // //           width: 68px; height: 68px; border-radius: 50%;
// // //           border: 1.5px solid rgba(201,168,76,.5);
// // //           z-index: 4; pointer-events: none;
// // //           animation: vts-pulse 2.4s ease-in-out infinite;
// // //         }
// // //         .vts-reel.playing .vts-pulse-ring { display: none; }

// // //         /* play/pause button */
// // //         .vts-play-area {
// // //           position: absolute; inset: 0;
// // //           display: flex; align-items: center; justify-content: center;
// // //           z-index: 5; pointer-events: none;
// // //         }
// // //         .vts-play-btn {
// // //           width: 68px; height: 68px; border-radius: 50%;
// // //           background: rgba(255,255,255,.12);
// // //           border: 2px solid rgba(255,255,255,.35);
// // //           backdrop-filter: blur(14px);
// // //           display: flex; align-items: center; justify-content: center;
// // //           transition: all .3s cubic-bezier(.25,1,.5,1);
// // //           box-shadow: 0 8px 32px rgba(0,0,0,.5);
// // //           opacity: 0; transform: scale(.8);
// // //           pointer-events: all; cursor: pointer;
// // //         }
// // //         .vts-play-btn.show {
// // //           opacity: 1; transform: scale(1);
// // //           animation: vts-ctrlIn .22s ease-out;
// // //         }
// // //         .vts-play-btn:hover {
// // //           background: ${C.gold}; border-color: ${C.gold};
// // //           box-shadow: 0 14px 44px rgba(201,168,76,.55);
// // //           transform: scale(1.08);
// // //         }
// // //         .vts-play-btn:hover svg { fill: ${C.dark}; }
// // //         .vts-play-btn svg { fill: #fff; transition: fill .2s; }

// // //         /* top-right controls */
// // //         .vts-top-ctrl {
// // //           position: absolute; top: 24px; right: 14px;
// // //           z-index: 7;
// // //           display: flex; flex-direction: column; align-items: center; gap: 8px;
// // //           opacity: 0; pointer-events: none;
// // //           transition: opacity .22s;
// // //         }
// // //         .vts-top-ctrl.show { opacity: 1; pointer-events: all; }
// // //         .vts-ctrl-btn {
// // //           width: 34px; height: 34px; border-radius: 50%;
// // //           background: rgba(0,0,0,.55); border: 1px solid rgba(255,255,255,.15);
// // //           color: #fff; font-size: 13px;
// // //           display: flex; align-items: center; justify-content: center;
// // //           cursor: pointer; backdrop-filter: blur(10px); transition: all .2s;
// // //         }
// // //         .vts-ctrl-btn:hover { background: rgba(201,168,76,.35); border-color: ${C.gold}; }
// // //         .vts-hint {
// // //           font-size: 10px; color: rgba(255,255,255,.4);
// // //           letter-spacing: .5px; text-transform: uppercase; text-align: center;
// // //           background: rgba(0,0,0,.45); backdrop-filter: blur(8px);
// // //           padding: 3px 8px; border-radius: 6px;
// // //           border: 1px solid rgba(255,255,255,.08); white-space: nowrap;
// // //         }

// // //         /* bottom info */
// // //         .vts-reel-info {
// // //           position: absolute; bottom: 0; left: 0; right: 0;
// // //           padding: 18px 16px 22px; z-index: 4;
// // //         }
// // //         .vts-stars { display: flex; gap: 3px; margin-bottom: 9px; }
// // //         .vts-quote {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 13px; font-style: italic; font-weight: 600;
// // //           color: #fff; line-height: 1.55; margin: 0 0 14px;
// // //           text-shadow: 0 1px 8px rgba(0,0,0,.6);
// // //           animation: vts-quoteIn .4s cubic-bezier(.25,1,.5,1) both;
// // //           display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;
// // //         }
// // //         .vts-quote::before {
// // //           content: '"'; font-size: 1.5em; line-height: 0;
// // //           vertical-align: -.35em; color: ${C.gold}; margin-right: 3px; opacity: .8;
// // //         }
// // //         .vts-identity {
// // //           display: flex; align-items: center; gap: 10px;
// // //           animation: vts-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;
// // //         }
// // //         .vts-avatar {
// // //           width: 38px; height: 38px; border-radius: 50%;
// // //           border: 2px solid rgba(201,168,76,.55);
// // //           background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
// // //           display: flex; align-items: center; justify-content: center;
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 12px; font-weight: 700; color: ${C.goldLight};
// // //           flex-shrink: 0;
// // //         }
// // //         .vts-name {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 3px;
// // //         }
// // //         .vts-meta { display: flex; align-items: center; gap: 5px; flex-wrap: wrap; }
// // //         .vts-pill {
// // //           background: rgba(201,168,76,.2); border: 1px solid rgba(201,168,76,.4);
// // //           color: ${C.goldLight}; font-size: 8px; font-weight: 800;
// // //           letter-spacing: 1.5px; text-transform: uppercase;
// // //           padding: 2px 8px; border-radius: 50px;
// // //         }
// // //         .vts-loc { font-size: 10px; color: rgba(255,255,255,.4); }

// // //         /* transition overlay */
// // //         .vts-transition {
// // //           position: absolute; inset: 0;
// // //           background: ${C.dark2}; z-index: 10;
// // //           opacity: 0; pointer-events: none; transition: opacity .28s;
// // //         }
// // //         .vts-transition.show { opacity: 1; pointer-events: all; }

// // //         /* queue sidebar */
// // //         .vts-queue {
// // //           background: rgba(255,255,255,.025);
// // //           border-left: 1px solid rgba(255,255,255,.06);
// // //           display: flex; flex-direction: column; overflow: hidden;
// // //         }
// // //         .vts-queue-header {
// // //           padding: 24px 24px 18px;
// // //           border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0;
// // //         }
// // //         .vts-queue-title {
// // //           font-size: 11px; font-weight: 700; letter-spacing: 2px;
// // //           text-transform: uppercase; color: rgba(255,255,255,.3);
// // //         }
// // //         .vts-queue-list {
// // //           flex: 1; overflow-y: auto; padding: 12px 0;
// // //           scrollbar-width: thin; scrollbar-color: rgba(201,168,76,.2) transparent;
// // //         }
// // //         .vts-queue-list::-webkit-scrollbar { width: 4px; }
// // //         .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

// // //         .vts-q-item {
// // //           display: flex; align-items: center; gap: 14px;
// // //           padding: 12px 20px; cursor: pointer; transition: all .25s;
// // //           border-left: 3px solid transparent;
// // //         }
// // //         .vts-q-item:hover { background: rgba(255,255,255,.04); }
// // //         .vts-q-item.active { background: rgba(201,168,76,.07); border-left-color: ${C.gold}; }

// // //         /* reel-shaped thumbnail — gradient + initials only, no image */
// // //         .vts-q-thumb {
// // //           width: 50px; height: 74px; border-radius: 10px; overflow: hidden;
// // //           flex-shrink: 0; position: relative;
// // //           border: 1px solid rgba(255,255,255,.07); transition: border-color .25s;
// // //           display: flex; align-items: center; justify-content: center;
// // //         }
// // //         .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
// // //         .vts-q-thumb-bg {
// // //           position: absolute; inset: 0;
// // //           background: linear-gradient(155deg, ${C.primaryDeep} 0%, ${C.primary} 60%, rgba(201,168,76,.25) 100%);
// // //         }
// // //         .vts-q-initials {
// // //           position: relative; z-index: 1;
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 13px; font-weight: 700; color: rgba(255,255,255,.75);
// // //           transition: color .2s;
// // //         }
// // //         .vts-q-item.active .vts-q-initials { color: ${C.goldLight}; }

// // //         .vts-q-eq-wrap {
// // //           position: absolute; inset: 0;
// // //           background: rgba(13,0,24,.65);
// // //           display: flex; align-items: center; justify-content: center;
// // //           border-radius: 9px; z-index: 2;
// // //         }
// // //         .vts-q-eq { display: flex; align-items: flex-end; gap: 2.5px; height: 18px; }
// // //         .vts-q-bar { width: 3px; background: ${C.gold}; border-radius: 2px; animation: vts-eqBar 1s ease-in-out infinite; }
// // //         .vts-q-bar:nth-child(2) { animation-delay: .18s; }
// // //         .vts-q-bar:nth-child(3) { animation-delay: .36s; }

// // //         .vts-q-info { flex: 1; min-width: 0; }
// // //         .vts-q-name {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 13px; font-weight: 700; color: #fff;
// // //           white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px;
// // //         }
// // //         .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
// // //         .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }
// // //         .vts-q-num {
// // //           font-size: 11px; color: rgba(255,255,255,.2); flex-shrink: 0;
// // //           font-family: 'Playfair Display', serif;
// // //         }
// // //         .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

// // //         .vts-queue-nav {
// // //           padding: 16px 20px;
// // //           border-top: 1px solid rgba(255,255,255,.06);
// // //           display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
// // //         }
// // //         .vts-nav-label { font-size: 11px; color: rgba(255,255,255,.25); letter-spacing: 1px; text-transform: uppercase; }
// // //         .vts-nav-arrows { display: flex; gap: 8px; }
// // //         .vts-nav-btn {
// // //           width: 38px; height: 38px; border-radius: 50%;
// // //           background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
// // //           color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
// // //           display: flex; align-items: center; justify-content: center;
// // //           cursor: pointer; transition: all .25s;
// // //         }
// // //         .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

// // //         /* bottom strip */
// // //         .vts-strip {
// // //           padding: 28px 60px 56px;
// // //           display: flex; align-items: center; justify-content: space-between;
// // //           gap: 20px; flex-wrap: wrap;
// // //           border-top: 1px solid rgba(255,255,255,.05);
// // //           position: relative; z-index: 2;
// // //         }
// // //         .vts-ratings { display: flex; align-items: center; gap: 28px; flex-wrap: wrap; }
// // //         .vts-r-item { text-align: center; }
// // //         .vts-r-num {
// // //           font-family: 'Playfair Display', serif;
// // //           font-size: 22px; font-weight: 700; color: ${C.gold}; line-height: 1;
// // //         }
// // //         .vts-r-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
// // //         .vts-r-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

// // //         .vts-btn-gold {
// // //           position: relative; overflow: hidden;
// // //           background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
// // //           background-size: 200% 200%; animation: vts-goldBg 3s ease infinite;
// // //           color: ${C.dark}; border: none; border-radius: 50px; padding: 13px 30px;
// // //           font-weight: 800; font-size: 14px; cursor: pointer;
// // //           box-shadow: 0 6px 24px rgba(201,168,76,.4);
// // //           display: inline-flex; align-items: center; gap: 8px;
// // //           font-family: 'DM Sans', sans-serif;
// // //           transition: transform .3s, box-shadow .3s;
// // //           text-decoration: none; flex-shrink: 0;
// // //         }
// // //         .vts-btn-gold::before {
// // //           content: ''; position: absolute; top: 0; left: -100%; width: 55%; height: 100%;
// // //           background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
// // //           animation: vts-shine 3s ease infinite;
// // //         }
// // //         .vts-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(201,168,76,.55); color: ${C.dark}; }

// // //         /* responsive */
// // //         @media (max-width: 1024px) {
// // //           .vts-stage { grid-template-columns: 1fr 280px; }
// // //           .vts-header, .vts-strip { padding-left: 32px; padding-right: 32px; }
// // //           .vts-reel-pane { padding-left: 40px; }
// // //         }
// // //         @media (max-width: 768px) {
// // //           .vts-stage { grid-template-columns: 1fr; grid-template-rows: auto auto; }
// // //           .vts-reel-pane { padding: 32px 20px; min-height: 480px; }
// // //           .vts-reel { width: min(250px, 74%); }
// // //           .vts-queue { border-left: none; border-top: 1px solid rgba(255,255,255,.06); max-height: 190px; }
// // //           .vts-queue-list { display: flex; flex-direction: row; overflow-y: hidden; overflow-x: auto; padding: 10px; gap: 10px; }
// // //           .vts-q-item { flex-direction: column; align-items: center; text-align: center; min-width: 84px; border-left: none; border-bottom: 3px solid transparent; padding: 8px; border-radius: 12px; }
// // //           .vts-q-item.active { border-bottom-color: ${C.gold}; border-left-color: transparent; }
// // //           .vts-q-thumb { width: 50px; height: 76px; }
// // //           .vts-q-num { display: none; }
// // //           .vts-header { padding: 40px 20px 32px; }
// // //           .vts-strip { padding: 20px 20px 36px; flex-direction: column; align-items: flex-start; }
// // //           .vts-r-sep { display: none; }
// // //         }
// // //         @media (max-width: 480px) {
// // //           .vts-h { font-size: clamp(24px, 7vw, 32px); }
// // //         }
// // //       `}</style>

// // //       <section className="vts-sec" id="video-testimonials" ref={sectionRef}>

// // //         {/* Header */}
// // //         <div className="vts-header">
// // //           <div>
// // //             <div className="vts-eyebrow">
// // //               <div className="vts-eyebrow-line" />
// // //               Customer Stories
// // //               <div className="vts-eyebrow-line" />
// // //             </div>
// // //             <h2 className="vts-h">
// // //               Real People,<br /><em>Real Celebrations</em>
// // //             </h2>
// // //           </div>
// // //           <div className="vts-counter">
// // //             <span>{String(activeIdx + 1).padStart(2, "0")}</span>
// // //             {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
// // //           </div>
// // //         </div>

// // //         {/* Stage */}
// // //         <div className="vts-stage">
// // //           <div className={`vts-transition${transitioning ? " show" : ""}`} />

// // //           {/* Reel Pane */}
// // //           <div className="vts-reel-pane">
// // //             <div className={`vts-glow-sphere${playing ? " playing-glow" : ""}`} />

// // //             <div
// // //               className={`vts-reel${playing ? " playing" : ""}`}
// // //               onMouseEnter={handleMouseEnter}
// // //               onMouseLeave={handleMouseLeave}
// // //               onMouseMove={handleMouseMove}
// // //               onTouchStart={handleTouchStart}
// // //             >
// // //               <div className="vts-notch" />

// // //               <div className="vts-prog">
// // //                 <div className="vts-prog-fill" style={{ width:`${progress}%` }} />
// // //               </div>

// // //               <video
// // //                 key={activeIdx}
// // //                 ref={videoRef}
// // //                 className="vts-video"
// // //                 src={cur.src}
// // //                 muted={muted}
// // //                 playsInline
// // //                 preload="metadata"
// // //               />

// // //               <div className="vts-ovl" />

// // //               {!playing && <div className="vts-pulse-ring" />}

// // //               <div className="vts-play-area">
// // //                 <button
// // //                   className={`vts-play-btn${showControls ? " show" : ""}`}
// // //                   onClick={togglePlay}
// // //                   aria-label={playing ? "Pause" : "Play"}
// // //                 >
// // //                   {playing
// // //                     ? <svg width="20" height="20" viewBox="0 0 24 24"><rect x="6"  y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>
// // //                     : <svg width="20" height="20" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
// // //                   }
// // //                 </button>
// // //               </div>

// // //               <div className={`vts-top-ctrl${showControls ? " show" : ""}`}>
// // //                 <button
// // //                   className="vts-ctrl-btn"
// // //                   onClick={e => { e.stopPropagation(); setMuted(m => !m); }}
// // //                   aria-label={muted ? "Unmute" : "Mute"}
// // //                 >
// // //                   {muted ? "🔇" : "🔊"}
// // //                 </button>
// // //                 <span className="vts-hint">{playing ? "Move away to stop" : "Hover to play"}</span>
// // //               </div>

// // //               <div className="vts-reel-info" key={activeIdx}>
// // //                 <div className="vts-stars">
// // //                   {[1,2,3,4,5].map(n => (
// // //                     <span key={n} style={{ fontSize:13, color: n <= cur.rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
// // //                   ))}
// // //                 </div>
// // //                 <p className="vts-quote">{cur.quote}</p>
// // //                 <div className="vts-identity">
// // //                   <div className="vts-avatar">
// // //                     {cur.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
// // //                   </div>
// // //                   <div>
// // //                     <div className="vts-name">{cur.name}</div>
// // //                     <div className="vts-meta">
// // //                       <span className="vts-pill">{cur.event}</span>
// // //                       <span className="vts-loc">📍 {cur.loc}</span>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>

// // //           {/* Queue Sidebar */}
// // //           <div className="vts-queue">
// // //             <div className="vts-queue-header">
// // //               <div className="vts-queue-title">Up Next</div>
// // //             </div>
// // //             <div className="vts-queue-list">
// // //               {TESTIMONIALS.map((t, i) => (
// // //                 <div
// // //                   key={i}
// // //                   className={`vts-q-item${i === activeIdx ? " active" : ""}`}
// // //                   onClick={() => goTo(i)}
// // //                 >
// // //                   <div className="vts-q-thumb">
// // //                     <div className="vts-q-thumb-bg" />
// // //                     <span className="vts-q-initials">
// // //                       {t.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
// // //                     </span>
// // //                     {i === activeIdx && playing && (
// // //                       <div className="vts-q-eq-wrap">
// // //                         <div className="vts-q-eq">
// // //                           <div className="vts-q-bar" />
// // //                           <div className="vts-q-bar" />
// // //                           <div className="vts-q-bar" />
// // //                         </div>
// // //                       </div>
// // //                     )}
// // //                   </div>
// // //                   <div className="vts-q-info">
// // //                     <div className="vts-q-name">{t.name}</div>
// // //                     <div className="vts-q-event">{t.event} · {t.loc}</div>
// // //                   </div>
// // //                   <div className="vts-q-num">{String(i + 1).padStart(2, "0")}</div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //             <div className="vts-queue-nav">
// // //               <span className="vts-nav-label">Navigate</span>
// // //               <div className="vts-nav-arrows">
// // //                 <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
// // //                 <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* Bottom strip */}
// // //         <div className="vts-strip">
// // //           <div className="vts-ratings">
// // //             {[
// // //               { num:"4.9★", label:"Google"       },
// // //               null,
// // //               { num:"4.8★", label:"Facebook"     },
// // //               null,
// // //               { num:"500+", label:"Happy Guests"  },
// // //               null,
// // //               { num:"98%",  label:"Would Return"  },
// // //             ].map((item, i) =>
// // //               item === null
// // //                 ? <div key={i} className="vts-r-sep" />
// // //                 : <div key={i} className="vts-r-item">
// // //                     <div className="vts-r-num">{item.num}</div>
// // //                     <div className="vts-r-label">{item.label}</div>
// // //                   </div>
// // //             )}
// // //           </div>
// // //           <a href="/locations" className="vts-btn-gold">🎉 Book Your Celebration</a>
// // //         </div>

// // //       </section>
// // //     </>
// // //   );
// // // }

// // import React, { useState, useRef, useEffect, useCallback } from "react";

// // const C = {
// //   primary:      "#5E0E73",
// //   primaryLight: "#6E1A85",
// //   primaryDeep:  "#3A0847",
// //   gold:         "#C9A84C",
// //   goldLight:    "#E8D5A0",
// //   goldBright:   "#F5D87A",
// //   dark:         "#1A0030",
// //   dark2:        "#120020",
// // };

// // const TESTIMONIALS = [
// //   {
// //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
// //     name:  "Aisha & Rahul",
// //     event: "Anniversary Night",
// //     loc:   "Banjara Hills",
// //     rating: 5,
// //   },
// //   {
// //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
// //     name:  "Karan Mehta",
// //     event: "Birthday Surprise",
// //     loc:   "Jubilee Hills",
// //     rating: 5,
// //   },
// //   {
// //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
// //     name:  "Rohit & Priya",
// //     event: "Love Proposal",
// //     loc:   "Kondapur",
// //     rating: 5,
// //   },
// //   {
// //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
// //     name:  "Sruthi Varma",
// //     event: "Bride To Be",
// //     loc:   "Madhapur",
// //     rating: 5,
// //   },
// //   {
// //     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
// //     name:  "Divya Nair",
// //     event: "Mom To Be",
// //     loc:   "Gachibowli",
// //     rating: 5,
// //   },
// // ];

// // export default function VideoTestimonialsSpotlight() {
// //   const [activeIdx,     setActiveIdx]     = useState(0);
// //   const [playing,       setPlaying]       = useState(false);
// //   const [progress,      setProgress]      = useState(0);
// //   const [transitioning, setTransitioning] = useState(false);

// //   const videoRef   = useRef(null);
// //   const sectionRef = useRef(null);
// //   const autoRef    = useRef(null);

// //   const cur = TESTIMONIALS[activeIdx];

// //   /* stop when scrolled out of view */
// //   useEffect(() => {
// //     const el = sectionRef.current;
// //     if (!el) return;
// //     const obs = new IntersectionObserver(
// //       ([entry]) => {
// //         if (!entry.isIntersecting) {
// //           videoRef.current?.pause();
// //           setPlaying(false);
// //         }
// //       },
// //       { threshold: 0.25 }
// //     );
// //     obs.observe(el);
// //     return () => obs.disconnect();
// //   }, []);

// //   /* reset on index change — always unmuted */
// //   useEffect(() => {
// //     const vid = videoRef.current;
// //     if (!vid) return;
// //     vid.pause();
// //     vid.currentTime = 0;
// //     vid.muted = false;
// //     setPlaying(false);
// //     setProgress(0);
// //   }, [activeIdx]);

// //   /* progress + ended */
// //   useEffect(() => {
// //     const vid = videoRef.current;
// //     if (!vid) return;
// //     const onTime = () => { if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100); };
// //     const onEnd  = () => { setPlaying(false); setProgress(0); };
// //     vid.addEventListener("timeupdate", onTime);
// //     vid.addEventListener("ended",     onEnd);
// //     return () => {
// //       vid.removeEventListener("timeupdate", onTime);
// //       vid.removeEventListener("ended",     onEnd);
// //     };
// //   }, [activeIdx]);

// //   const isTouchDevice = () => window.matchMedia("(hover:none) and (pointer:coarse)").matches;

// //   /* toggle play — always unmuted */
// //   const togglePlay = () => {
// //     const vid = videoRef.current;
// //     if (!vid) return;
// //     if (playing) {
// //       vid.pause();
// //       vid.muted = false;
// //       setPlaying(false);
// //     } else {
// //       vid.muted = false;
// //       vid.play().then(() => setPlaying(true)).catch(() => {});
// //     }
// //   };

// //   /* desktop hover — autoplay on enter, stop on leave */
// //   const handleMouseEnter = () => {
// //     if (isTouchDevice()) return;
// //     const vid = videoRef.current;
// //     if (vid && !playing) {
// //       vid.muted = false;
// //       vid.play().then(() => setPlaying(true)).catch(() => {});
// //     }
// //   };
// //   const handleMouseLeave = () => {
// //     if (isTouchDevice()) return;
// //     if (videoRef.current && playing) {
// //       videoRef.current.pause();
// //       setPlaying(false);
// //     }
// //   };

// //   /* reel click = play/pause (works for both touch tap and desktop click) */
// //   const handleReelClick = () => togglePlay();

// //   /* play button click — stop propagation so it doesn't double-fire with reel click */
// //   const handlePlayBtnClick = (e) => {
// //     e.stopPropagation();
// //     togglePlay();
// //   };

// //   const goTo = useCallback((i) => {
// //     if (i === activeIdx || transitioning) return;
// //     setTransitioning(true);
// //     setTimeout(() => { setActiveIdx(i); setTransitioning(false); }, 300);
// //   }, [activeIdx, transitioning]);

// //   const goPrev = () => goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
// //   const goNext = () => goTo((activeIdx + 1) % TESTIMONIALS.length);

// //   /* auto-advance only when not playing */
// //   useEffect(() => {
// //     if (!playing) {
// //       autoRef.current = setInterval(() => {
// //         setActiveIdx(i => (i + 1) % TESTIMONIALS.length);
// //       }, 5000);
// //     } else {
// //       clearInterval(autoRef.current);
// //     }
// //     return () => clearInterval(autoRef.current);
// //   }, [playing]);

// //   return (
// //     <>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// //         @keyframes vts-goldBg  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
// //         @keyframes vts-shine   { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
// //         @keyframes vts-pulse   { 0%,100%{transform:scale(1);opacity:.45} 50%{transform:scale(1.2);opacity:.85} }
// //         @keyframes vts-nameIn  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
// //         @keyframes vts-eqBar   { 0%,100%{height:5px} 50%{height:18px} }
// //         @keyframes vts-ctrlIn  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

// //         .vts-sec {
// //           background: ${C.dark2};
// //           font-family: 'DM Sans', sans-serif;
// //           position: relative; overflow: hidden;
// //         }
// //         .vts-sec::before {
// //           content: ''; position: absolute; inset: 0;
// //           background:
// //             radial-gradient(ellipse 65% 50% at 20% 10%, rgba(94,14,115,.28) 0%, transparent 65%),
// //             radial-gradient(ellipse 50% 40% at 80% 90%, rgba(201,168,76,.08) 0%, transparent 65%);
// //           pointer-events: none; z-index: 0;
// //         }
// //         .vts-sec::after {
// //           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
// //           width: 180px; height: 2px;
// //           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
// //         }

// //         /* header */
// //         .vts-header {
// //           padding: 72px clamp(20px,5vw,60px) 52px;
// //           display: flex; align-items: flex-end;
// //           justify-content: space-between; flex-wrap: wrap; gap: 20px;
// //           position: relative; z-index: 2;
// //         }
// //         .vts-header::after {
// //           content: ''; position: absolute; bottom: 0;
// //           left: clamp(20px,5vw,60px); right: clamp(20px,5vw,60px);
// //           height: 1px;
// //           background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
// //         }
// //         .vts-eyebrow {
// //           display: flex; align-items: center; gap: 10px;
// //           font-size: 11px; font-weight: 700; letter-spacing: 3px;
// //           text-transform: uppercase; color: ${C.gold}; margin-bottom: 14px;
// //         }
// //         .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }
// //         .vts-h {
// //           font-family: 'Playfair Display', serif;
// //           font-size: clamp(28px, 4vw, 46px);
// //           font-weight: 700; color: #fff; line-height: 1.1; margin: 0;
// //         }
// //         .vts-h em { font-style: italic; color: ${C.gold}; }
// //         .vts-counter {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 14px; color: rgba(255,255,255,.3); flex-shrink: 0; align-self: flex-end;
// //         }
// //         .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

// //         /* stage */
// //         .vts-stage {
// //           display: grid; grid-template-columns: 1fr 340px;
// //           min-height: 580px; position: relative; z-index: 1;
// //         }

// //         /* reel pane */
// //         .vts-reel-pane {
// //           position: relative;
// //           display: flex; align-items: center; justify-content: center;
// //           padding: 40px 0 40px clamp(20px,5vw,60px);
// //           overflow: hidden;
// //         }

// //         /* ambient glow sphere */
// //         .vts-glow-sphere {
// //           position: absolute;
// //           width: 420px; height: 420px; border-radius: 50%;
// //           background: radial-gradient(circle, rgba(94,14,115,.22) 0%, transparent 70%);
// //           top: 50%; left: 45%; transform: translate(-50%, -50%);
// //           pointer-events: none; z-index: 0;
// //           transition: background .5s;
// //         }
// //         .vts-glow-sphere.playing-glow {
// //           background: radial-gradient(circle, rgba(201,168,76,.1) 0%, rgba(94,14,115,.15) 50%, transparent 70%);
// //         }

// //         /* reel container — 9:16 portrait */
// //         .vts-reel {
// //           position: relative;
// //           width: min(300px, 82%);
// //           aspect-ratio: 9 / 16;
// //           border-radius: 32px;
// //           overflow: hidden;
// //           background: #000;
// //           border: 2px solid rgba(255,255,255,.1);
// //           box-shadow:
// //             0 40px 100px rgba(0,0,0,.7),
// //             0 0 0 1px rgba(255,255,255,.04),
// //             inset 0 1px 0 rgba(255,255,255,.08);
// //           cursor: pointer;
// //           transition: border-color .35s, box-shadow .4s;
// //           z-index: 1;
// //           flex-shrink: 0;
// //           -webkit-tap-highlight-color: transparent;
// //           user-select: none;
// //         }
// //         .vts-reel:hover,
// //         .vts-reel.playing {
// //           border-color: rgba(201,168,76,.5);
// //           box-shadow:
// //             0 50px 120px rgba(0,0,0,.75),
// //             0 0 60px rgba(201,168,76,.14),
// //             0 0 0 1px rgba(255,255,255,.06),
// //             inset 0 1px 0 rgba(255,255,255,.1);
// //         }

// //         /* notch */
// //         .vts-notch {
// //           position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
// //           width: 80px; height: 5px;
// //           background: rgba(255,255,255,.1); border-radius: 3px;
// //           z-index: 8; pointer-events: none;
// //         }

// //         /* progress bar */
// //         .vts-prog {
// //           position: absolute; top: 0; left: 0; right: 0;
// //           height: 3px; background: rgba(255,255,255,.08); z-index: 6;
// //         }
// //         .vts-prog-fill {
// //           height: 100%;
// //           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
// //           border-radius: 0 2px 2px 0;
// //           transition: width .1s linear;
// //         }

// //         /* video */
// //         .vts-video {
// //           position: absolute; inset: 0;
// //           width: 100%; height: 100%;
// //           object-fit: cover; display: block;
// //         }

// //         /* gradient overlay */
// //         .vts-ovl {
// //           position: absolute; inset: 0;
// //           background:
// //             linear-gradient(to top,  rgba(13,0,24,.96) 0%, rgba(13,0,24,.22) 45%, transparent 100%),
// //             linear-gradient(to bottom, rgba(13,0,24,.5) 0%, transparent 25%);
// //           pointer-events: none; z-index: 2;
// //         }

// //         /* idle pulse ring */
// //         .vts-pulse-ring {
// //           position: absolute; top: 50%; left: 50%;
// //           transform: translate(-50%, -50%);
// //           width: 68px; height: 68px; border-radius: 50%;
// //           border: 1.5px solid rgba(201,168,76,.5);
// //           z-index: 4; pointer-events: none;
// //           animation: vts-pulse 2.4s ease-in-out infinite;
// //         }
// //         .vts-reel.playing .vts-pulse-ring { display: none; }

// //         /* play button — visible only when NOT playing, always on touch */
// //         .vts-play-area {
// //           position: absolute; inset: 0;
// //           display: flex; align-items: center; justify-content: center;
// //           z-index: 5; pointer-events: none;
// //         }
// //         .vts-play-btn {
// //           width: 68px; height: 68px; border-radius: 50%;
// //           background: rgba(255,255,255,.12);
// //           border: 2px solid rgba(255,255,255,.35);
// //           backdrop-filter: blur(14px);
// //           display: flex; align-items: center; justify-content: center;
// //           transition: all .3s cubic-bezier(.25,1,.5,1);
// //           box-shadow: 0 8px 32px rgba(0,0,0,.5);
// //           animation: vts-ctrlIn .22s ease-out;
// //           pointer-events: all; cursor: pointer;
// //         }
// //         .vts-play-btn:hover {
// //           background: ${C.gold}; border-color: ${C.gold};
// //           box-shadow: 0 14px 44px rgba(201,168,76,.55);
// //           transform: scale(1.08);
// //         }
// //         .vts-play-btn:hover svg { fill: ${C.dark}; }
// //         .vts-play-btn svg { fill: #fff; transition: fill .2s; }

// //         /* always show play btn on touch devices */
// //         @media(hover:none) and (pointer:coarse) {
// //           .vts-play-btn {
// //             opacity: 1 !important;
// //             background: rgba(201,168,76,.85);
// //           }
// //           .vts-play-btn svg { fill: ${C.dark}; }
// //         }

// //         /* bottom info — only stars + name + avatar */
// //         .vts-reel-info {
// //           position: absolute; bottom: 0; left: 0; right: 0;
// //           padding: 18px 16px 22px; z-index: 4;
// //         }
// //         .vts-stars { display: flex; gap: 3px; margin-bottom: 10px; }
// //         .vts-identity {
// //           display: flex; align-items: center; gap: 10px;
// //           animation: vts-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;
// //         }
// //         .vts-avatar {
// //           width: 38px; height: 38px; border-radius: 50%;
// //           border: 2px solid rgba(201,168,76,.55);
// //           background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
// //           display: flex; align-items: center; justify-content: center;
// //           font-family: 'Playfair Display', serif;
// //           font-size: 12px; font-weight: 700; color: ${C.goldLight};
// //           flex-shrink: 0;
// //         }
// //         .vts-name {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 0;
// //         }

// //         /* transition overlay */
// //         .vts-transition {
// //           position: absolute; inset: 0;
// //           background: ${C.dark2}; z-index: 10;
// //           opacity: 0; pointer-events: none; transition: opacity .28s;
// //         }
// //         .vts-transition.show { opacity: 1; pointer-events: all; }

// //         /* queue sidebar */
// //         .vts-queue {
// //           background: rgba(255,255,255,.025);
// //           border-left: 1px solid rgba(255,255,255,.06);
// //           display: flex; flex-direction: column; overflow: hidden;
// //         }
// //         .vts-queue-header {
// //           padding: 24px 24px 18px;
// //           border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0;
// //         }
// //         .vts-queue-title {
// //           font-size: 11px; font-weight: 700; letter-spacing: 2px;
// //           text-transform: uppercase; color: rgba(255,255,255,.3);
// //         }
// //         .vts-queue-list {
// //           flex: 1; overflow-y: auto; padding: 12px 0;
// //           scrollbar-width: thin; scrollbar-color: rgba(201,168,76,.2) transparent;
// //         }
// //         .vts-queue-list::-webkit-scrollbar { width: 4px; }
// //         .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

// //         .vts-q-item {
// //           display: flex; align-items: center; gap: 14px;
// //           padding: 12px 20px; cursor: pointer; transition: all .25s;
// //           border-left: 3px solid transparent;
// //         }
// //         .vts-q-item:hover { background: rgba(255,255,255,.04); }
// //         .vts-q-item.active { background: rgba(201,168,76,.07); border-left-color: ${C.gold}; }

// //         .vts-q-thumb {
// //           width: 50px; height: 74px; border-radius: 10px; overflow: hidden;
// //           flex-shrink: 0; position: relative;
// //           border: 1px solid rgba(255,255,255,.07); transition: border-color .25s;
// //           display: flex; align-items: center; justify-content: center;
// //         }
// //         .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
// //         .vts-q-thumb-bg {
// //           position: absolute; inset: 0;
// //           background: linear-gradient(155deg, ${C.primaryDeep} 0%, ${C.primary} 60%, rgba(201,168,76,.25) 100%);
// //         }
// //         .vts-q-initials {
// //           position: relative; z-index: 1;
// //           font-family: 'Playfair Display', serif;
// //           font-size: 13px; font-weight: 700; color: rgba(255,255,255,.75);
// //           transition: color .2s;
// //         }
// //         .vts-q-item.active .vts-q-initials { color: ${C.goldLight}; }

// //         .vts-q-eq-wrap {
// //           position: absolute; inset: 0;
// //           background: rgba(13,0,24,.65);
// //           display: flex; align-items: center; justify-content: center;
// //           border-radius: 9px; z-index: 2;
// //         }
// //         .vts-q-eq { display: flex; align-items: flex-end; gap: 2.5px; height: 18px; }
// //         .vts-q-bar { width: 3px; background: ${C.gold}; border-radius: 2px; animation: vts-eqBar 1s ease-in-out infinite; }
// //         .vts-q-bar:nth-child(2) { animation-delay: .18s; }
// //         .vts-q-bar:nth-child(3) { animation-delay: .36s; }

// //         .vts-q-info { flex: 1; min-width: 0; }
// //         .vts-q-name {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 13px; font-weight: 700; color: #fff;
// //           white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px;
// //         }
// //         .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
// //         .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }
// //         .vts-q-num {
// //           font-size: 11px; color: rgba(255,255,255,.2); flex-shrink: 0;
// //           font-family: 'Playfair Display', serif;
// //         }
// //         .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

// //         .vts-queue-nav {
// //           padding: 16px 20px;
// //           border-top: 1px solid rgba(255,255,255,.06);
// //           display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
// //         }
// //         .vts-nav-label { font-size: 11px; color: rgba(255,255,255,.25); letter-spacing: 1px; text-transform: uppercase; }
// //         .vts-nav-arrows { display: flex; gap: 8px; }
// //         .vts-nav-btn {
// //           width: 38px; height: 38px; border-radius: 50%;
// //           background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
// //           color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
// //           display: flex; align-items: center; justify-content: center;
// //           cursor: pointer; transition: all .25s;
// //         }
// //         .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

// //         /* bottom strip */
// //         .vts-strip {
// //           padding: 28px clamp(20px,5vw,60px) 56px;
// //           display: flex; align-items: center; justify-content: space-between;
// //           gap: 20px; flex-wrap: wrap;
// //           border-top: 1px solid rgba(255,255,255,.05);
// //           position: relative; z-index: 2;
// //         }
// //         .vts-ratings { display: flex; align-items: center; gap: 28px; flex-wrap: wrap; }
// //         .vts-r-item { text-align: center; }
// //         .vts-r-num {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 22px; font-weight: 700; color: ${C.gold}; line-height: 1;
// //         }
// //         .vts-r-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
// //         .vts-r-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

// //         .vts-btn-gold {
// //           position: relative; overflow: hidden;
// //           background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
// //           background-size: 200% 200%; animation: vts-goldBg 3s ease infinite;
// //           color: ${C.dark}; border: none; border-radius: 50px; padding: 13px 30px;
// //           font-weight: 800; font-size: 14px; cursor: pointer;
// //           box-shadow: 0 6px 24px rgba(201,168,76,.4);
// //           display: inline-flex; align-items: center; gap: 8px;
// //           font-family: 'DM Sans', sans-serif;
// //           transition: transform .3s, box-shadow .3s;
// //           text-decoration: none; flex-shrink: 0;
// //         }
// //         .vts-btn-gold::before {
// //           content: ''; position: absolute; top: 0; left: -100%; width: 55%; height: 100%;
// //           background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
// //           animation: vts-shine 3s ease infinite;
// //         }
// //         .vts-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(201,168,76,.55); color: ${C.dark}; }

// //         /* responsive */
// //         @media (max-width: 1024px) {
// //           .vts-stage { grid-template-columns: 1fr 280px; }
// //         }
// //         @media (max-width: 768px) {
// //           .vts-stage { grid-template-columns: 1fr; grid-template-rows: auto auto; }
// //           .vts-reel-pane { padding: 32px 20px; min-height: 480px; }
// //           .vts-reel { width: min(250px, 74%); }
// //           .vts-queue {
// //             border-left: none;
// //             border-top: 1px solid rgba(255,255,255,.06);
// //             max-height: none;
// //           }
// //           .vts-queue-list {
// //             display: flex; flex-direction: row;
// //             overflow-x: auto; overflow-y: hidden;
// //             padding: 10px 16px 14px; gap: 10px;
// //             -webkit-overflow-scrolling: touch;
// //           }
// //           .vts-queue-list::-webkit-scrollbar { display: none; }
// //           .vts-q-item {
// //             flex-direction: column; align-items: center; text-align: center;
// //             min-width: 84px; border-left: none;
// //             border-bottom: 3px solid transparent;
// //             padding: 8px; border-radius: 12px;
// //           }
// //           .vts-q-item.active { border-bottom-color: ${C.gold}; border-left-color: transparent; }
// //           .vts-q-thumb { width: 50px; height: 76px; }
// //           .vts-q-num { display: none; }
// //           .vts-strip { flex-direction: column; align-items: flex-start; }
// //           .vts-r-sep { display: none; }
// //         }
// //         @media (max-width: 480px) {
// //           .vts-h { font-size: clamp(24px, 7vw, 32px); }
// //         }
// //       `}</style>

// //       <section className="vts-sec" id="video-testimonials" ref={sectionRef}>

// //         {/* Header */}
// //         <div className="vts-header">
// //           <div>
// //             <div className="vts-eyebrow">
// //               <div className="vts-eyebrow-line" />
// //               Customer Stories
// //               <div className="vts-eyebrow-line" />
// //             </div>
// //             <h2 className="vts-h">
// //               Real People,<br /><em>Real Celebrations</em>
// //             </h2>
// //           </div>
// //           <div className="vts-counter">
// //             <span>{String(activeIdx + 1).padStart(2, "0")}</span>
// //             {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
// //           </div>
// //         </div>

// //         {/* Stage */}
// //         <div className="vts-stage">
// //           <div className={`vts-transition${transitioning ? " show" : ""}`} />

// //           {/* Reel Pane */}
// //           <div className="vts-reel-pane">
// //             <div className={`vts-glow-sphere${playing ? " playing-glow" : ""}`} />

// //             <div
// //               className={`vts-reel${playing ? " playing" : ""}`}
// //               onMouseEnter={handleMouseEnter}
// //               onMouseLeave={handleMouseLeave}
// //               onClick={handleReelClick}
// //             >
// //               <div className="vts-notch" />

// //               <div className="vts-prog">
// //                 <div className="vts-prog-fill" style={{ width:`${progress}%` }} />
// //               </div>

// //               {/* always unmuted */}
// //               <video
// //                 key={activeIdx}
// //                 ref={videoRef}
// //                 className="vts-video"
// //                 src={cur.src}
// //                 muted={false}
// //                 playsInline
// //                 preload="metadata"
// //               />

// //               <div className="vts-ovl" />

// //               {/* pulse ring — hidden when playing */}
// //               {!playing && <div className="vts-pulse-ring" />}

// //               {/* play button — hidden when playing, always visible on touch */}
// //               {!playing && (
// //                 <div className="vts-play-area">
// //                   <button className="vts-play-btn" onClick={handlePlayBtnClick} aria-label="Play">
// //                     <svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
// //                   </button>
// //                 </div>
// //               )}

// //               {/* info — stars + name only, no quote/pill/loc */}
// //               <div className="vts-reel-info" key={activeIdx}>
// //                 <div className="vts-stars">
// //                   {[1,2,3,4,5].map(n => (
// //                     <span key={n} style={{ fontSize:13, color: n <= cur.rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
// //                   ))}
// //                 </div>
// //                 <div className="vts-identity">
// //                   <div className="vts-avatar">
// //                     {cur.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
// //                   </div>
// //                   <div>
// //                     <div className="vts-name">{cur.name}</div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Queue Sidebar */}
// //           <div className="vts-queue">
// //             <div className="vts-queue-header">
// //               <div className="vts-queue-title">Up Next</div>
// //             </div>
// //             <div className="vts-queue-list">
// //               {TESTIMONIALS.map((t, i) => (
// //                 <div
// //                   key={i}
// //                   className={`vts-q-item${i === activeIdx ? " active" : ""}`}
// //                   onClick={() => goTo(i)}
// //                 >
// //                   <div className="vts-q-thumb">
// //                     <div className="vts-q-thumb-bg" />
// //                     <span className="vts-q-initials">
// //                       {t.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
// //                     </span>
// //                     {i === activeIdx && playing && (
// //                       <div className="vts-q-eq-wrap">
// //                         <div className="vts-q-eq">
// //                           <div className="vts-q-bar" />
// //                           <div className="vts-q-bar" />
// //                           <div className="vts-q-bar" />
// //                         </div>
// //                       </div>
// //                     )}
// //                   </div>
// //                   <div className="vts-q-info">
// //                     <div className="vts-q-name">{t.name}</div>
// //                     <div className="vts-q-event">{t.event} · {t.loc}</div>
// //                   </div>
// //                   <div className="vts-q-num">{String(i + 1).padStart(2, "0")}</div>
// //                 </div>
// //               ))}
// //             </div>
// //             <div className="vts-queue-nav">
// //               <span className="vts-nav-label">Navigate</span>
// //               <div className="vts-nav-arrows">
// //                 <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
// //                 <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Bottom strip */}
// //         <div className="vts-strip">
// //           <div className="vts-ratings">
// //             {[
// //               { num:"4.9★", label:"Google" },
// //               null,
// //               { num:"5★", label:"By Families" },
// //               null,
             
// //               { num:"5★",  label:"Rated By Couples" },
// //               null,
// //              { num:"50k+", label:"Happy Customers" },
// //               {}
// //             ].map((item, i) =>
// //               item === null
// //                 ? <div key={i} className="vts-r-sep" />
// //                 : <div key={i} className="vts-r-item">
// //                     <div className="vts-r-num">{item.num}</div>
// //                     <div className="vts-r-label">{item.label}</div>
// //                   </div>
// //             )}
// //           </div>
// //           <a href="/locations" className="vts-btn-gold">🎉 Book Your Celebration</a>
// //         </div>

// //       </section>
// //     </>
// //   );
// // }

// import React, { useState, useRef, useEffect, useCallback } from "react";

// const C = {
//   primary:      "#5E0E73",
//   primaryLight: "#6E1A85",
//   primaryDeep:  "#3A0847",
//   gold:         "#C9A84C",
//   goldLight:    "#E8D5A0",
//   goldBright:   "#F5D87A",
//   dark:         "#1A0030",
//   dark2:        "#120020",
// };

// const TESTIMONIALS = [
//   {
//     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
//     name:  "Aisha & Rahul",
//     event: "Anniversary Night",
//     loc:   "Banjara Hills",
//     rating: 5,
//   },
//   {
//     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
//     name:  "Karan Mehta",
//     event: "Birthday Surprise",
//     loc:   "Jubilee Hills",
//     rating: 5,
//   },
//   {
//     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
//     name:  "Rohit & Priya",
//     event: "Love Proposal",
//     loc:   "Kondapur",
//     rating: 5,
//   },
//   {
//     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
//     name:  "Sruthi Varma",
//     event: "Bride To Be",
//     loc:   "Madhapur",
//     rating: 5,
//   },
//   {
//     src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
//     name:  "Divya Nair",
//     event: "Mom To Be",
//     loc:   "Gachibowli",
//     rating: 5,
//   },
// ];

// export default function VideoTestimonialsSpotlight() {
//   const [activeIdx,     setActiveIdx]     = useState(0);
//   const [playing,       setPlaying]       = useState(false);
//   const [progress,      setProgress]      = useState(0);
//   const [transitioning, setTransitioning] = useState(false);

//   const videoRef   = useRef(null);
//   const sectionRef = useRef(null);
//   const autoRef    = useRef(null);

//   const cur = TESTIMONIALS[activeIdx];

//   /* stop when scrolled out of view */
//   useEffect(() => {
//     const el = sectionRef.current;
//     if (!el) return;
//     const obs = new IntersectionObserver(
//       ([entry]) => {
//         if (!entry.isIntersecting) {
//           videoRef.current?.pause();
//           setPlaying(false);
//         }
//       },
//       { threshold: 0.25 }
//     );
//     obs.observe(el);
//     return () => obs.disconnect();
//   }, []);

//   /* reset on index change — always unmuted */
//   useEffect(() => {
//     const vid = videoRef.current;
//     if (!vid) return;
//     vid.pause();
//     vid.currentTime = 0;
//     vid.muted = false;
//     setPlaying(false);
//     setProgress(0);
//   }, [activeIdx]);

//   /* progress + ended */
//   useEffect(() => {
//     const vid = videoRef.current;
//     if (!vid) return;
//     const onTime = () => { if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100); };
//     const onEnd  = () => { setPlaying(false); setProgress(0); };
//     vid.addEventListener("timeupdate", onTime);
//     vid.addEventListener("ended",     onEnd);
//     return () => {
//       vid.removeEventListener("timeupdate", onTime);
//       vid.removeEventListener("ended",     onEnd);
//     };
//   }, [activeIdx]);

//   const isTouchDevice = () => window.matchMedia("(hover:none) and (pointer:coarse)").matches;

//   /* toggle play — always unmuted */
//   const togglePlay = () => {
//     const vid = videoRef.current;
//     if (!vid) return;
//     if (playing) {
//       vid.pause();
//       vid.muted = false;
//       setPlaying(false);
//     } else {
//       vid.muted = false;
//       vid.play().then(() => setPlaying(true)).catch(() => {});
//     }
//   };

//   /* desktop hover — autoplay on enter, stop on leave */
//   const handleMouseEnter = () => {
//     if (isTouchDevice()) return;
//     const vid = videoRef.current;
//     if (vid && !playing) {
//       vid.muted = false;
//       vid.play().then(() => setPlaying(true)).catch(() => {});
//     }
//   };
//   const handleMouseLeave = () => {
//     if (isTouchDevice()) return;
//     if (videoRef.current && playing) {
//       videoRef.current.pause();
//       setPlaying(false);
//     }
//   };

//   /* reel click = play/pause */
//   const handleReelClick = () => togglePlay();

//   /* play button click — stop propagation so it doesn't double-fire with reel click */
//   const handlePlayBtnClick = (e) => {
//     e.stopPropagation();
//     togglePlay();
//   };

//   const goTo = useCallback((i) => {
//     if (i === activeIdx || transitioning) return;
//     setTransitioning(true);
//     setTimeout(() => { setActiveIdx(i); setTransitioning(false); }, 300);
//   }, [activeIdx, transitioning]);

//   const goPrev = () => goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
//   const goNext = () => goTo((activeIdx + 1) % TESTIMONIALS.length);

//   /* auto-advance only when not playing */
//   useEffect(() => {
//     if (!playing) {
//       autoRef.current = setInterval(() => {
//         setActiveIdx(i => (i + 1) % TESTIMONIALS.length);
//       }, 5000);
//     } else {
//       clearInterval(autoRef.current);
//     }
//     return () => clearInterval(autoRef.current);
//   }, [playing]);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

//         @keyframes vts-goldBg  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
//         @keyframes vts-shine   { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
//         @keyframes vts-pulse   { 0%,100%{transform:scale(1);opacity:.45} 50%{transform:scale(1.2);opacity:.85} }
//         @keyframes vts-nameIn  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
//         @keyframes vts-eqBar   { 0%,100%{height:5px} 50%{height:18px} }
//         @keyframes vts-ctrlIn  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

//         .vts-sec {
//           background: ${C.dark2};
//           font-family: 'DM Sans', sans-serif;
//           position: relative; overflow: hidden;
//         }
//         .vts-sec::before {
//           content: ''; position: absolute; inset: 0;
//           background:
//             radial-gradient(ellipse 65% 50% at 20% 10%, rgba(94,14,115,.28) 0%, transparent 65%),
//             radial-gradient(ellipse 50% 40% at 80% 90%, rgba(201,168,76,.08) 0%, transparent 65%);
//           pointer-events: none; z-index: 0;
//         }
//         .vts-sec::after {
//           content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
//           width: 180px; height: 2px;
//           background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
//         }

//         /* header */
//         .vts-header {
//           padding: 72px clamp(20px,5vw,60px) 52px;
//           display: flex; align-items: flex-end;
//           justify-content: space-between; flex-wrap: wrap; gap: 20px;
//           position: relative; z-index: 2;
//         }
//         .vts-header::after {
//           content: ''; position: absolute; bottom: 0;
//           left: clamp(20px,5vw,60px); right: clamp(20px,5vw,60px);
//           height: 1px;
//           background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
//         }
//         .vts-eyebrow {
//           display: flex; align-items: center; gap: 10px;
//           font-size: 11px; font-weight: 700; letter-spacing: 3px;
//           text-transform: uppercase; color: ${C.gold}; margin-bottom: 14px;
//         }
//         .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }
//         .vts-h {
//           font-family: 'Playfair Display', serif;
//           font-size: clamp(28px, 4vw, 46px);
//           font-weight: 700; color: #fff; line-height: 1.1; margin: 0;
//         }
//         .vts-h em { font-style: italic; color: ${C.gold}; }
//         .vts-counter {
//           font-family: 'Playfair Display', serif;
//           font-size: 14px; color: rgba(255,255,255,.3); flex-shrink: 0; align-self: flex-end;
//         }
//         .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

//         /* stage */
//         .vts-stage {
//           display: grid; grid-template-columns: 1fr 340px;
//           min-height: 580px; position: relative; z-index: 1;
//         }

//         /* reel pane */
//         .vts-reel-pane {
//           position: relative;
//           display: flex; align-items: center; justify-content: center;
//           padding: 40px 0 40px clamp(20px,5vw,60px);
//           overflow: hidden;
//         }

//         /* ambient glow sphere */
//         .vts-glow-sphere {
//           position: absolute;
//           width: 420px; height: 420px; border-radius: 50%;
//           background: radial-gradient(circle, rgba(94,14,115,.22) 0%, transparent 70%);
//           top: 50%; left: 45%; transform: translate(-50%, -50%);
//           pointer-events: none; z-index: 0;
//           transition: background .5s;
//         }
//         .vts-glow-sphere.playing-glow {
//           background: radial-gradient(circle, rgba(201,168,76,.1) 0%, rgba(94,14,115,.15) 50%, transparent 70%);
//         }

//         /* reel container — 9:16 portrait */
//         .vts-reel {
//           position: relative;
//           width: min(300px, 82%);
//           aspect-ratio: 9 / 16;
//           border-radius: 32px;
//           overflow: hidden;
//           background: #000;
//           border: 2px solid rgba(255,255,255,.1);
//           box-shadow:
//             0 40px 100px rgba(0,0,0,.7),
//             0 0 0 1px rgba(255,255,255,.04),
//             inset 0 1px 0 rgba(255,255,255,.08);
//           cursor: pointer;
//           transition: border-color .35s, box-shadow .4s;
//           z-index: 1;
//           flex-shrink: 0;
//           -webkit-tap-highlight-color: transparent;
//           user-select: none;
//         }
//         .vts-reel:hover,
//         .vts-reel.playing {
//           border-color: rgba(201,168,76,.5);
//           box-shadow:
//             0 50px 120px rgba(0,0,0,.75),
//             0 0 60px rgba(201,168,76,.14),
//             0 0 0 1px rgba(255,255,255,.06),
//             inset 0 1px 0 rgba(255,255,255,.1);
//         }

//         /* notch */
//         .vts-notch {
//           position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
//           width: 80px; height: 5px;
//           background: rgba(255,255,255,.1); border-radius: 3px;
//           z-index: 8; pointer-events: none;
//         }

//         /* progress bar */
//         .vts-prog {
//           position: absolute; top: 0; left: 0; right: 0;
//           height: 3px; background: rgba(255,255,255,.08); z-index: 6;
//         }
//         .vts-prog-fill {
//           height: 100%;
//           background: linear-gradient(90deg, ${C.primary}, ${C.gold});
//           border-radius: 0 2px 2px 0;
//           transition: width .1s linear;
//         }

//         /* video */
//         .vts-video {
//           position: absolute; inset: 0;
//           width: 100%; height: 100%;
//           object-fit: cover; display: block;
//         }

//         /* ─── FIX: lighter overlay so video thumbnail shows when paused ─── */
//         .vts-ovl {
//           position: absolute; inset: 0;
//           background:
//             linear-gradient(to top,  rgba(13,0,24,.55) 0%, rgba(13,0,24,.08) 38%, transparent 100%),
//             linear-gradient(to bottom, rgba(13,0,24,.25) 0%, transparent 20%);
//           pointer-events: none; z-index: 2;
//         }

//         /* idle pulse ring */
//         .vts-pulse-ring {
//           position: absolute; top: 50%; left: 50%;
//           transform: translate(-50%, -50%);
//           width: 68px; height: 68px; border-radius: 50%;
//           border: 1.5px solid rgba(201,168,76,.5);
//           z-index: 4; pointer-events: none;
//           animation: vts-pulse 2.4s ease-in-out infinite;
//         }
//         .vts-reel.playing .vts-pulse-ring { display: none; }

//         /* play button — visible only when NOT playing, always on touch */
//         .vts-play-area {
//           position: absolute; inset: 0;
//           display: flex; align-items: center; justify-content: center;
//           z-index: 5; pointer-events: none;
//         }
//         .vts-play-btn {
//           width: 68px; height: 68px; border-radius: 50%;
//           background: rgba(255,255,255,.12);
//           border: 2px solid rgba(255,255,255,.35);
//           backdrop-filter: blur(14px);
//           display: flex; align-items: center; justify-content: center;
//           transition: all .3s cubic-bezier(.25,1,.5,1);
//           box-shadow: 0 8px 32px rgba(0,0,0,.5);
//           animation: vts-ctrlIn .22s ease-out;
//           pointer-events: all; cursor: pointer;
//         }
//         .vts-play-btn:hover {
//           background: ${C.gold}; border-color: ${C.gold};
//           box-shadow: 0 14px 44px rgba(201,168,76,.55);
//           transform: scale(1.08);
//         }
//         .vts-play-btn:hover svg { fill: ${C.dark}; }
//         .vts-play-btn svg { fill: #fff; transition: fill .2s; }

//         /* always show play btn on touch devices */
//         @media(hover:none) and (pointer:coarse) {
//           .vts-play-btn {
//             opacity: 1 !important;
//             background: rgba(201,168,76,.85);
//           }
//           .vts-play-btn svg { fill: ${C.dark}; }
//         }

//         /* bottom info — only stars + name + avatar */
//         .vts-reel-info {
//           position: absolute; bottom: 0; left: 0; right: 0;
//           padding: 18px 16px 22px; z-index: 4;
//         }
//         .vts-stars { display: flex; gap: 3px; margin-bottom: 10px; }
//         .vts-identity {
//           display: flex; align-items: center; gap: 10px;
//           animation: vts-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;
//         }
//         .vts-avatar {
//           width: 38px; height: 38px; border-radius: 50%;
//           border: 2px solid rgba(201,168,76,.55);
//           background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
//           display: flex; align-items: center; justify-content: center;
//           font-family: 'Playfair Display', serif;
//           font-size: 12px; font-weight: 700; color: ${C.goldLight};
//           flex-shrink: 0;
//         }
//         .vts-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 0;
//         }

//         /* transition overlay */
//         .vts-transition {
//           position: absolute; inset: 0;
//           background: ${C.dark2}; z-index: 10;
//           opacity: 0; pointer-events: none; transition: opacity .28s;
//         }
//         .vts-transition.show { opacity: 1; pointer-events: all; }

//         /* queue sidebar */
//         .vts-queue {
//           background: rgba(255,255,255,.025);
//           border-left: 1px solid rgba(255,255,255,.06);
//           display: flex; flex-direction: column; overflow: hidden;
//         }
//         .vts-queue-header {
//           padding: 24px 24px 18px;
//           border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0;
//         }
//         .vts-queue-title {
//           font-size: 11px; font-weight: 700; letter-spacing: 2px;
//           text-transform: uppercase; color: rgba(255,255,255,.3);
//         }
//         .vts-queue-list {
//           flex: 1; overflow-y: auto; padding: 12px 0;
//           scrollbar-width: thin; scrollbar-color: rgba(201,168,76,.2) transparent;
//         }
//         .vts-queue-list::-webkit-scrollbar { width: 4px; }
//         .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

//         .vts-q-item {
//           display: flex; align-items: center; gap: 14px;
//           padding: 12px 20px; cursor: pointer; transition: all .25s;
//           border-left: 3px solid transparent;
//         }
//         .vts-q-item:hover { background: rgba(255,255,255,.04); }
//         .vts-q-item.active { background: rgba(201,168,76,.07); border-left-color: ${C.gold}; }

//         .vts-q-thumb {
//           width: 50px; height: 74px; border-radius: 10px; overflow: hidden;
//           flex-shrink: 0; position: relative;
//           border: 1px solid rgba(255,255,255,.07); transition: border-color .25s;
//           display: flex; align-items: center; justify-content: center;
//         }
//         .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
//         .vts-q-thumb-bg {
//           position: absolute; inset: 0;
//           background: linear-gradient(155deg, ${C.primaryDeep} 0%, ${C.primary} 60%, rgba(201,168,76,.25) 100%);
//         }
//         .vts-q-initials {
//           position: relative; z-index: 1;
//           font-family: 'Playfair Display', serif;
//           font-size: 13px; font-weight: 700; color: rgba(255,255,255,.75);
//           transition: color .2s;
//         }
//         .vts-q-item.active .vts-q-initials { color: ${C.goldLight}; }

//         .vts-q-eq-wrap {
//           position: absolute; inset: 0;
//           background: rgba(13,0,24,.65);
//           display: flex; align-items: center; justify-content: center;
//           border-radius: 9px; z-index: 2;
//         }
//         .vts-q-eq { display: flex; align-items: flex-end; gap: 2.5px; height: 18px; }
//         .vts-q-bar { width: 3px; background: ${C.gold}; border-radius: 2px; animation: vts-eqBar 1s ease-in-out infinite; }
//         .vts-q-bar:nth-child(2) { animation-delay: .18s; }
//         .vts-q-bar:nth-child(3) { animation-delay: .36s; }

//         .vts-q-info { flex: 1; min-width: 0; }
//         .vts-q-name {
//           font-family: 'Playfair Display', serif;
//           font-size: 13px; font-weight: 700; color: #fff;
//           white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px;
//         }
//         .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
//         .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }
//         .vts-q-num {
//           font-size: 11px; color: rgba(255,255,255,.2); flex-shrink: 0;
//           font-family: 'Playfair Display', serif;
//         }
//         .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

//         .vts-queue-nav {
//           padding: 16px 20px;
//           border-top: 1px solid rgba(255,255,255,.06);
//           display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
//         }
//         .vts-nav-label { font-size: 11px; color: rgba(255,255,255,.25); letter-spacing: 1px; text-transform: uppercase; }
//         .vts-nav-arrows { display: flex; gap: 8px; }
//         .vts-nav-btn {
//           width: 38px; height: 38px; border-radius: 50%;
//           background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
//           color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
//           display: flex; align-items: center; justify-content: center;
//           cursor: pointer; transition: all .25s;
//         }
//         .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

//         /* ─── Mobile navigation arrows ─── */
//         .vts-mobile-nav {
//           display: none;
//         }

//         /* bottom strip */
//         .vts-strip {
//           padding: 28px clamp(20px,5vw,60px) 56px;
//           display: flex; align-items: center; justify-content: space-between;
//           gap: 20px; flex-wrap: wrap;
//           border-top: 1px solid rgba(255,255,255,.05);
//           position: relative; z-index: 2;
//         }
//         .vts-ratings { display: flex; align-items: center; gap: 28px; flex-wrap: wrap; }
//         .vts-r-item { text-align: center; }
//         .vts-r-num {
//           font-family: 'Playfair Display', serif;
//           font-size: 22px; font-weight: 700; color: ${C.gold}; line-height: 1;
//         }
//         .vts-r-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
//         .vts-r-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

//         .vts-btn-gold {
//           position: relative; overflow: hidden;
//           background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
//           background-size: 200% 200%; animation: vts-goldBg 3s ease infinite;
//           color: ${C.dark}; border: none; border-radius: 50px; padding: 13px 30px;
//           font-weight: 800; font-size: 14px; cursor: pointer;
//           box-shadow: 0 6px 24px rgba(201,168,76,.4);
//           display: inline-flex; align-items: center; gap: 8px;
//           font-family: 'DM Sans', sans-serif;
//           transition: transform .3s, box-shadow .3s;
//           text-decoration: none; flex-shrink: 0;
//         }
//         .vts-btn-gold::before {
//           content: ''; position: absolute; top: 0; left: -100%; width: 55%; height: 100%;
//           background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
//           animation: vts-shine 3s ease infinite;
//         }
//         .vts-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(201,168,76,.55); color: ${C.dark}; }

//         /* responsive */
//         @media (max-width: 1024px) {
//           .vts-stage { grid-template-columns: 1fr 280px; }
//         }
//         @media (max-width: 768px) {
//           .vts-stage { grid-template-columns: 1fr; grid-template-rows: auto auto; }
//           .vts-reel-pane { padding: 32px 20px; min-height: 480px; }
//           .vts-reel { width: min(250px, 74%); }
//           .vts-queue {
//             border-left: none;
//             border-top: 1px solid rgba(255,255,255,.06);
//             max-height: none;
//           }
//           .vts-queue-list {
//             display: flex; flex-direction: row;
//             overflow-x: auto; overflow-y: hidden;
//             padding: 10px 16px 14px; gap: 10px;
//             -webkit-overflow-scrolling: touch;
//           }
//           .vts-queue-list::-webkit-scrollbar { display: none; }
//           .vts-q-item {
//             flex-direction: column; align-items: center; text-align: center;
//             min-width: 84px; border-left: none;
//             border-bottom: 3px solid transparent;
//             padding: 8px; border-radius: 12px;
//           }
//           .vts-q-item.active { border-bottom-color: ${C.gold}; border-left-color: transparent; }
//           .vts-q-thumb { width: 50px; height: 76px; }
//           .vts-q-num { display: none; }
//           .vts-strip { flex-direction: column; align-items: flex-start; }
//           .vts-r-sep { display: none; }

//           /* ─── Show mobile nav arrows ─── */
//           .vts-mobile-nav {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             gap: 20px;
//             padding: 16px 20px 4px;
//             position: relative;
//             z-index: 2;
//           }
//           .vts-mobile-nav-btn {
//             width: 48px; height: 48px; border-radius: 50%;
//             background: rgba(255,255,255,.07);
//             border: 1px solid rgba(255,255,255,.18);
//             color: rgba(255,255,255,.75);
//             font-size: 24px; font-weight: 700;
//             display: flex; align-items: center; justify-content: center;
//             cursor: pointer; transition: all .25s;
//             -webkit-tap-highlight-color: transparent;
//             user-select: none;
//           }
//           .vts-mobile-nav-btn:active {
//             background: ${C.gold};
//             color: ${C.dark};
//             border-color: ${C.gold};
//             transform: scale(0.94);
//           }
//           .vts-mobile-nav-counter {
//             font-family: 'Playfair Display', serif;
//             font-size: 13px;
//             color: rgba(255,255,255,.3);
//             min-width: 52px;
//             text-align: center;
//             user-select: none;
//           }
//           .vts-mobile-nav-counter span {
//             color: #fff;
//             font-size: 16px;
//             font-weight: 700;
//           }
//         }
//         @media (max-width: 480px) {
//           .vts-h { font-size: clamp(24px, 7vw, 32px); }
//         }
//       `}</style>

//       <section className="vts-sec" id="video-testimonials" ref={sectionRef}>

//         {/* Header */}
//         <div className="vts-header">
//           <div>
//             <div className="vts-eyebrow">
//               <div className="vts-eyebrow-line" />
//               Customer Stories
//               <div className="vts-eyebrow-line" />
//             </div>
//             <h2 className="vts-h">
//               Real People,<br /><em>Real Celebrations</em>
//             </h2>
//           </div>
//           <div className="vts-counter">
//             <span>{String(activeIdx + 1).padStart(2, "0")}</span>
//             {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
//           </div>
//         </div>

//         {/* Stage */}
//         <div className="vts-stage">
//           <div className={`vts-transition${transitioning ? " show" : ""}`} />

//           {/* Reel Pane */}
//           <div className="vts-reel-pane">
//             <div className={`vts-glow-sphere${playing ? " playing-glow" : ""}`} />

//             <div
//               className={`vts-reel${playing ? " playing" : ""}`}
//               onMouseEnter={handleMouseEnter}
//               onMouseLeave={handleMouseLeave}
//               onClick={handleReelClick}
//             >
//               <div className="vts-notch" />

//               <div className="vts-prog">
//                 <div className="vts-prog-fill" style={{ width:`${progress}%` }} />
//               </div>

//               <video
//                 key={activeIdx}
//                 ref={videoRef}
//                 className="vts-video"
//                 src={cur.src}
//                 muted={false}
//                 playsInline
//                 preload="metadata"
//               />

//               <div className="vts-ovl" />

//               {/* pulse ring — hidden when playing */}
//               {!playing && <div className="vts-pulse-ring" />}

//               {/* play button — hidden when playing, always visible on touch */}
//               {!playing && (
//                 <div className="vts-play-area">
//                   <button className="vts-play-btn" onClick={handlePlayBtnClick} aria-label="Play">
//                     <svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
//                   </button>
//                 </div>
//               )}

//               {/* info — stars + name only */}
//               <div className="vts-reel-info" key={activeIdx}>
//                 <div className="vts-stars">
//                   {[1,2,3,4,5].map(n => (
//                     <span key={n} style={{ fontSize:13, color: n <= cur.rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
//                   ))}
//                 </div>
//                 <div className="vts-identity">
//                   <div className="vts-avatar">
//                     {cur.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
//                   </div>
//                   <div>
//                     <div className="vts-name">{cur.name}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Queue Sidebar */}
//           <div className="vts-queue">
//             <div className="vts-queue-header">
//               <div className="vts-queue-title">Up Next</div>
//             </div>
//             <div className="vts-queue-list">
//               {TESTIMONIALS.map((t, i) => (
//                 <div
//                   key={i}
//                   className={`vts-q-item${i === activeIdx ? " active" : ""}`}
//                   onClick={() => goTo(i)}
//                 >
//                   <div className="vts-q-thumb">
//                     <div className="vts-q-thumb-bg" />
//                     <span className="vts-q-initials">
//                       {t.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
//                     </span>
//                     {i === activeIdx && playing && (
//                       <div className="vts-q-eq-wrap">
//                         <div className="vts-q-eq">
//                           <div className="vts-q-bar" />
//                           <div className="vts-q-bar" />
//                           <div className="vts-q-bar" />
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                   <div className="vts-q-info">
//                     <div className="vts-q-name">{t.name}</div>
//                     <div className="vts-q-event">{t.event} · {t.loc}</div>
//                   </div>
//                   <div className="vts-q-num">{String(i + 1).padStart(2, "0")}</div>
//                 </div>
//               ))}
//             </div>
//             <div className="vts-queue-nav">
//               <span className="vts-nav-label">Navigate</span>
//               <div className="vts-nav-arrows">
//                 <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
//                 <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ─── Mobile prev/next arrows — only visible on ≤768px ─── */}
//         <div className="vts-mobile-nav">
//           <button className="vts-mobile-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
//           <div className="vts-mobile-nav-counter">
//             <span>{String(activeIdx + 1).padStart(2, "0")}</span>
//             {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
//           </div>
//           <button className="vts-mobile-nav-btn" onClick={goNext} aria-label="Next">›</button>
//         </div>

//         {/* Bottom strip */}
//         <div className="vts-strip">
//           <div className="vts-ratings">
//             {[
//               { num:"4.9★", label:"Google" },
//               null,
//               { num:"5★", label:"By Families" },
//               null,
//               { num:"5★",  label:"Rated By Couples" },
//               null,
//               { num:"50k+", label:"Happy Customers" },
//             ].map((item, i) =>
//               item === null
//                 ? <div key={i} className="vts-r-sep" />
//                 : <div key={i} className="vts-r-item">
//                     <div className="vts-r-num">{item.num}</div>
//                     <div className="vts-r-label">{item.label}</div>
//                   </div>
//             )}
//           </div>
//           <a href="/locations" className="vts-btn-gold">🎉 Book Your Celebration</a>
//         </div>

//       </section>
//     </>
//   );
// }

import React, { useState, useRef, useEffect, useCallback } from "react";

const C = {
  primary:      "#5E0E73",
  primaryLight: "#6E1A85",
  primaryDeep:  "#3A0847",
  gold:         "#C9A84C",
  goldLight:    "#E8D5A0",
  goldBright:   "#F5D87A",
  dark:         "#1A0030",
  dark2:        "#120020",
};

const TESTIMONIALS = [
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name:  "Aisha & Rahul",
    event: "Anniversary Night",
    loc:   "Banjara Hills",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
    name:  "Karan Mehta",
    event: "Birthday Surprise",
    loc:   "Jubilee Hills",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
    name:  "Rohit & Priya",
    event: "Love Proposal",
    loc:   "Kondapur",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name:  "Sruthi Varma",
    event: "Bride To Be",
    loc:   "Madhapur",
    rating: 5,
  },
  {
    src:   "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
    name:  "Divya Nair",
    event: "Mom To Be",
    loc:   "Gachibowli",
    rating: 5,
  },
];

export default function VideoTestimonialsSpotlight() {
  const [activeIdx,     setActiveIdx]     = useState(0);
  const [playing,       setPlaying]       = useState(false);
  const [progress,      setProgress]      = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const videoRef   = useRef(null);
  const sectionRef = useRef(null);
  const autoRef    = useRef(null);

  const cur = TESTIMONIALS[activeIdx];

  /* stop when scrolled out of view */
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          videoRef.current?.pause();
          setPlaying(false);
        }
      },
      { threshold: 0.25 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  /* reset on index change */
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    vid.pause();
    vid.currentTime = 0;
    vid.muted = false;
    setPlaying(false);
    setProgress(0);
  }, [activeIdx]);

  /* progress + ended */
  useEffect(() => {
    const vid = videoRef.current;
    if (!vid) return;
    const onTime = () => { if (vid.duration) setProgress((vid.currentTime / vid.duration) * 100); };
    const onEnd  = () => { setPlaying(false); setProgress(0); };
    vid.addEventListener("timeupdate", onTime);
    vid.addEventListener("ended",     onEnd);
    return () => {
      vid.removeEventListener("timeupdate", onTime);
      vid.removeEventListener("ended",     onEnd);
    };
  }, [activeIdx]);

  const isTouchDevice = () => window.matchMedia("(hover:none) and (pointer:coarse)").matches;

  const togglePlay = () => {
    const vid = videoRef.current;
    if (!vid) return;
    if (playing) {
      vid.pause();
      vid.muted = false;
      setPlaying(false);
    } else {
      vid.muted = false;
      vid.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  const handleMouseEnter = () => {
    if (isTouchDevice()) return;
    const vid = videoRef.current;
    if (vid && !playing) {
      vid.muted = false;
      vid.play().then(() => setPlaying(true)).catch(() => {});
    }
  };
  const handleMouseLeave = () => {
    if (isTouchDevice()) return;
    if (videoRef.current && playing) {
      videoRef.current.pause();
      setPlaying(false);
    }
  };

  const handleReelClick = () => togglePlay();

  const handlePlayBtnClick = (e) => {
    e.stopPropagation();
    togglePlay();
  };

  const goTo = useCallback((i) => {
    if (i === activeIdx || transitioning) return;
    setTransitioning(true);
    setTimeout(() => { setActiveIdx(i); setTransitioning(false); }, 300);
  }, [activeIdx, transitioning]);

  const goPrev = (e) => { e.stopPropagation(); goTo((activeIdx - 1 + TESTIMONIALS.length) % TESTIMONIALS.length); };
  const goNext = (e) => { e.stopPropagation(); goTo((activeIdx + 1) % TESTIMONIALS.length); };

  /* auto-advance only when not playing */
  useEffect(() => {
    if (!playing) {
      autoRef.current = setInterval(() => {
        setActiveIdx(i => (i + 1) % TESTIMONIALS.length);
      }, 5000);
    } else {
      clearInterval(autoRef.current);
    }
    return () => clearInterval(autoRef.current);
  }, [playing]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

        @keyframes vts-goldBg  { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }
        @keyframes vts-shine   { 0%{left:-100%} 25%{left:130%} 100%{left:130%} }
        @keyframes vts-pulse   { 0%,100%{transform:scale(1);opacity:.45} 50%{transform:scale(1.2);opacity:.85} }
        @keyframes vts-nameIn  { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes vts-eqBar   { 0%,100%{height:5px} 50%{height:18px} }
        @keyframes vts-ctrlIn  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

        .vts-sec {
          background: ${C.dark2};
          font-family: 'DM Sans', sans-serif;
          position: relative; overflow: hidden;
        }
        .vts-sec::before {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 65% 50% at 20% 10%, rgba(94,14,115,.28) 0%, transparent 65%),
            radial-gradient(ellipse 50% 40% at 80% 90%, rgba(201,168,76,.08) 0%, transparent 65%);
          pointer-events: none; z-index: 0;
        }
        .vts-sec::after {
          content: ''; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
          width: 180px; height: 2px;
          background: linear-gradient(90deg, transparent, ${C.gold}, transparent);
        }

        /* ── header ── */
        .vts-header {
          padding: 72px clamp(20px,5vw,60px) 52px;
          display: flex; align-items: flex-end;
          justify-content: space-between; flex-wrap: wrap; gap: 20px;
          position: relative; z-index: 2;
        }
        .vts-header::after {
          content: ''; position: absolute; bottom: 0;
          left: clamp(20px,5vw,60px); right: clamp(20px,5vw,60px);
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(201,168,76,.25), transparent);
        }
        .vts-eyebrow {
          display: flex; align-items: center; gap: 10px;
          font-size: 11px; font-weight: 700; letter-spacing: 3px;
          text-transform: uppercase; color: ${C.gold}; margin-bottom: 14px;
        }
        .vts-eyebrow-line { width: 26px; height: 1px; background: ${C.gold}; opacity: .55; }
        .vts-h {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 4vw, 46px);
          font-weight: 700; color: #fff; line-height: 1.1; margin: 0;
        }
        .vts-h em { font-style: italic; color: ${C.gold}; }
        .vts-counter {
          font-family: 'Playfair Display', serif;
          font-size: 14px; color: rgba(255,255,255,.3); flex-shrink: 0; align-self: flex-end;
        }
        .vts-counter span { color: #fff; font-size: 18px; font-weight: 700; }

        /* ── stage ── */
        .vts-stage {
          display: grid; grid-template-columns: 1fr 340px;
          min-height: 580px; position: relative; z-index: 1;
        }

        /* ── reel pane — arrows float left/right of the reel ── */
        .vts-reel-pane {
          position: relative;
          display: flex; align-items: center; justify-content: center;
          padding: 40px 0 40px clamp(20px,5vw,60px);
          overflow: hidden;
          gap: 0;
        }

        /* side arrow buttons */
        .vts-side-arr {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 44px; height: 44px; border-radius: 50%;
          background: rgba(255,255,255,.08);
          border: 1px solid rgba(255,255,255,.18);
          color: rgba(255,255,255,.8);
          font-size: 22px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; z-index: 10;
          transition: all .25s cubic-bezier(.25,1,.5,1);
          backdrop-filter: blur(10px);
          -webkit-tap-highlight-color: transparent;
          user-select: none;
          line-height: 1;
        }
        .vts-side-arr:hover {
          background: ${C.gold};
          color: ${C.dark};
          border-color: ${C.gold};
          box-shadow: 0 6px 24px rgba(201,168,76,.5);
          transform: translateY(-50%) scale(1.1);
        }
        .vts-side-arr:active {
          transform: translateY(-50%) scale(0.94);
        }
        /* position: sit just outside the reel edges with a comfortable gap */
        .vts-side-arr.prev { left: clamp(4px, 2vw, 20px); }
        .vts-side-arr.next { right: clamp(4px, 2vw, 20px); }

        /* ambient glow sphere */
        .vts-glow-sphere {
          position: absolute;
          width: 420px; height: 420px; border-radius: 50%;
          background: radial-gradient(circle, rgba(94,14,115,.22) 0%, transparent 70%);
          top: 50%; left: 45%; transform: translate(-50%, -50%);
          pointer-events: none; z-index: 0;
          transition: background .5s;
        }
        .vts-glow-sphere.playing-glow {
          background: radial-gradient(circle, rgba(201,168,76,.1) 0%, rgba(94,14,115,.15) 50%, transparent 70%);
        }

        /* reel container — 9:16 portrait */
        .vts-reel {
          position: relative;
          width: min(300px, 60%);
          aspect-ratio: 9 / 16;
          border-radius: 32px;
          overflow: hidden;
          background: transparent;
          border: 2px solid rgba(255,255,255,.1);
          box-shadow:
            0 40px 100px rgba(0,0,0,.7),
            0 0 0 1px rgba(255,255,255,.04),
            inset 0 1px 0 rgba(255,255,255,.08);
          cursor: pointer;
          transition: border-color .35s, box-shadow .4s;
          z-index: 1;
          flex-shrink: 0;
          -webkit-tap-highlight-color: transparent;
          user-select: none;
        }
        .vts-reel:hover,
        .vts-reel.playing {
          border-color: rgba(201,168,76,.5);
          box-shadow:
            0 50px 120px rgba(0,0,0,.75),
            0 0 60px rgba(201,168,76,.14),
            0 0 0 1px rgba(255,255,255,.06),
            inset 0 1px 0 rgba(255,255,255,.1);
        }

        /* notch */
        .vts-notch {
          position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
          width: 80px; height: 5px;
          background: rgba(255,255,255,.1); border-radius: 3px;
          z-index: 8; pointer-events: none;
        }

        /* progress bar */
        .vts-prog {
          position: absolute; top: 0; left: 0; right: 0;
          height: 3px; background: rgba(255,255,255,.08); z-index: 6;
        }
        .vts-prog-fill {
          height: 100%;
          background: linear-gradient(90deg, ${C.primary}, ${C.gold});
          border-radius: 0 2px 2px 0;
          transition: width .1s linear;
        }

        /* video — fills the reel fully, thumbnail visible with no overlay */
        .vts-video {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          object-fit: cover; display: block;
        }

        /* ── OVERLAY: only a slim bottom gradient for text legibility, zero top dark ── */
        .vts-ovl {
          position: absolute; inset: 0;
          background: linear-gradient(to top, rgba(10,0,20,.7) 0%, rgba(10,0,20,.15) 32%, transparent 52%);
          pointer-events: none; z-index: 2;
        }
        /* remove overlay entirely when paused so thumbnail is fully clean */
        .vts-reel:not(.playing) .vts-ovl {
          background: linear-gradient(to top, rgba(10,0,20,.55) 0%, transparent 40%);
        }

        /* idle pulse ring */
        .vts-pulse-ring {
          position: absolute; top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 68px; height: 68px; border-radius: 50%;
          border: 1.5px solid rgba(201,168,76,.5);
          z-index: 4; pointer-events: none;
          animation: vts-pulse 2.4s ease-in-out infinite;
        }
        .vts-reel.playing .vts-pulse-ring { display: none; }

        /* play button */
        .vts-play-area {
          position: absolute; inset: 0;
          display: flex; align-items: center; justify-content: center;
          z-index: 5; pointer-events: none;
        }
        .vts-play-btn {
          width: 68px; height: 68px; border-radius: 50%;
          background: rgba(255,255,255,.14);
          border: 2px solid rgba(255,255,255,.4);
          backdrop-filter: blur(14px);
          display: flex; align-items: center; justify-content: center;
          transition: all .3s cubic-bezier(.25,1,.5,1);
          box-shadow: 0 8px 32px rgba(0,0,0,.4);
          animation: vts-ctrlIn .22s ease-out;
          pointer-events: all; cursor: pointer;
        }
        .vts-play-btn:hover {
          background: ${C.gold}; border-color: ${C.gold};
          box-shadow: 0 14px 44px rgba(201,168,76,.55);
          transform: scale(1.08);
        }
        .vts-play-btn:hover svg { fill: ${C.dark}; }
        .vts-play-btn svg { fill: #fff; transition: fill .2s; }

        @media(hover:none) and (pointer:coarse) {
          .vts-play-btn {
            opacity: 1 !important;
            background: rgba(201,168,76,.85);
          }
          .vts-play-btn svg { fill: ${C.dark}; }
        }

        /* bottom info */
        .vts-reel-info {
          position: absolute; bottom: 0; left: 0; right: 0;
          padding: 18px 16px 22px; z-index: 4;
        }
        .vts-stars { display: flex; gap: 3px; margin-bottom: 10px; }
        .vts-identity {
          display: flex; align-items: center; gap: 10px;
          animation: vts-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;
        }
        .vts-avatar {
          width: 38px; height: 38px; border-radius: 50%;
          border: 2px solid rgba(201,168,76,.55);
          background: linear-gradient(135deg, ${C.primary}, ${C.primaryLight});
          display: flex; align-items: center; justify-content: center;
          font-family: 'Playfair Display', serif;
          font-size: 12px; font-weight: 700; color: ${C.goldLight};
          flex-shrink: 0;
        }
        .vts-name {
          font-family: 'Playfair Display', serif;
          font-size: 13px; font-weight: 700; color: #fff; margin-bottom: 0;
        }

        /* transition overlay */
        .vts-transition {
          position: absolute; inset: 0;
          background: ${C.dark2}; z-index: 10;
          opacity: 0; pointer-events: none; transition: opacity .28s;
        }
        .vts-transition.show { opacity: 1; pointer-events: all; }

        /* queue sidebar */
        .vts-queue {
          background: rgba(255,255,255,.025);
          border-left: 1px solid rgba(255,255,255,.06);
          display: flex; flex-direction: column; overflow: hidden;
        }
        .vts-queue-header {
          padding: 24px 24px 18px;
          border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0;
        }
        .vts-queue-title {
          font-size: 11px; font-weight: 700; letter-spacing: 2px;
          text-transform: uppercase; color: rgba(255,255,255,.3);
        }
        .vts-queue-list {
          flex: 1; overflow-y: auto; padding: 12px 0;
          scrollbar-width: thin; scrollbar-color: rgba(201,168,76,.2) transparent;
        }
        .vts-queue-list::-webkit-scrollbar { width: 4px; }
        .vts-queue-list::-webkit-scrollbar-thumb { background: rgba(201,168,76,.2); border-radius: 2px; }

        .vts-q-item {
          display: flex; align-items: center; gap: 14px;
          padding: 12px 20px; cursor: pointer; transition: all .25s;
          border-left: 3px solid transparent;
        }
        .vts-q-item:hover { background: rgba(255,255,255,.04); }
        .vts-q-item.active { background: rgba(201,168,76,.07); border-left-color: ${C.gold}; }

        .vts-q-thumb {
          width: 50px; height: 74px; border-radius: 10px; overflow: hidden;
          flex-shrink: 0; position: relative;
          border: 1px solid rgba(255,255,255,.07); transition: border-color .25s;
          display: flex; align-items: center; justify-content: center;
        }
        .vts-q-item.active .vts-q-thumb { border-color: rgba(201,168,76,.4); }
        .vts-q-thumb-bg {
          position: absolute; inset: 0;
          background: linear-gradient(155deg, ${C.primaryDeep} 0%, ${C.primary} 60%, rgba(201,168,76,.25) 100%);
        }
        .vts-q-initials {
          position: relative; z-index: 1;
          font-family: 'Playfair Display', serif;
          font-size: 13px; font-weight: 700; color: rgba(255,255,255,.75);
          transition: color .2s;
        }
        .vts-q-item.active .vts-q-initials { color: ${C.goldLight}; }

        .vts-q-eq-wrap {
          position: absolute; inset: 0;
          background: rgba(13,0,24,.65);
          display: flex; align-items: center; justify-content: center;
          border-radius: 9px; z-index: 2;
        }
        .vts-q-eq { display: flex; align-items: flex-end; gap: 2.5px; height: 18px; }
        .vts-q-bar { width: 3px; background: ${C.gold}; border-radius: 2px; animation: vts-eqBar 1s ease-in-out infinite; }
        .vts-q-bar:nth-child(2) { animation-delay: .18s; }
        .vts-q-bar:nth-child(3) { animation-delay: .36s; }

        .vts-q-info { flex: 1; min-width: 0; }
        .vts-q-name {
          font-family: 'Playfair Display', serif;
          font-size: 13px; font-weight: 700; color: #fff;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px;
        }
        .vts-q-item.active .vts-q-name { color: ${C.goldLight}; }
        .vts-q-event { font-size: 11px; color: rgba(255,255,255,.35); }
        .vts-q-num {
          font-size: 11px; color: rgba(255,255,255,.2); flex-shrink: 0;
          font-family: 'Playfair Display', serif;
        }
        .vts-q-item.active .vts-q-num { color: ${C.gold}; font-weight: 700; }

        .vts-queue-nav {
          padding: 16px 20px;
          border-top: 1px solid rgba(255,255,255,.06);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .vts-nav-label { font-size: 11px; color: rgba(255,255,255,.25); letter-spacing: 1px; text-transform: uppercase; }
        .vts-nav-arrows { display: flex; gap: 8px; }
        .vts-nav-btn {
          width: 38px; height: 38px; border-radius: 50%;
          background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
          color: rgba(255,255,255,.55); font-size: 17px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all .25s;
        }
        .vts-nav-btn:hover { background: ${C.gold}; color: ${C.dark}; border-color: ${C.gold}; }

        /* bottom strip */
        .vts-strip {
          padding: 28px clamp(20px,5vw,60px) 56px;
          display: flex; align-items: center; justify-content: space-between;
          gap: 20px; flex-wrap: wrap;
          border-top: 1px solid rgba(255,255,255,.05);
          position: relative; z-index: 2;
        }
        .vts-ratings { display: flex; align-items: center; gap: 28px; flex-wrap: wrap; }
        .vts-r-item { text-align: center; }
        .vts-r-num {
          font-family: 'Playfair Display', serif;
          font-size: 22px; font-weight: 700; color: ${C.gold}; line-height: 1;
        }
        .vts-r-label { font-size: 10px; color: rgba(255,255,255,.28); text-transform: uppercase; letter-spacing: 1px; margin-top: 4px; }
        .vts-r-sep { width: 1px; height: 36px; background: rgba(255,255,255,.06); }

        .vts-btn-gold {
          position: relative; overflow: hidden;
          background: linear-gradient(135deg, #B8860B, ${C.gold}, ${C.goldBright}, ${C.gold}, #9A6E10);
          background-size: 200% 200%; animation: vts-goldBg 3s ease infinite;
          color: ${C.dark}; border: none; border-radius: 50px; padding: 13px 30px;
          font-weight: 800; font-size: 14px; cursor: pointer;
          box-shadow: 0 6px 24px rgba(201,168,76,.4);
          display: inline-flex; align-items: center; gap: 8px;
          font-family: 'DM Sans', sans-serif;
          transition: transform .3s, box-shadow .3s;
          text-decoration: none; flex-shrink: 0;
        }
        .vts-btn-gold::before {
          content: ''; position: absolute; top: 0; left: -100%; width: 55%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
          animation: vts-shine 3s ease infinite;
        }
        .vts-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(201,168,76,.55); color: ${C.dark}; }

        /* ── responsive ── */
        @media (max-width: 1024px) {
          .vts-stage { grid-template-columns: 1fr 280px; }
        }

        @media (max-width: 768px) {
          .vts-stage { grid-template-columns: 1fr; grid-template-rows: auto auto; }
          .vts-reel-pane { padding: 32px 64px; min-height: 480px; }
          .vts-reel { width: min(240px, 68%); }

          /* side arrows — stay left/right of the reel on mobile too */
          .vts-side-arr.prev { left: 10px; }
          .vts-side-arr.next { right: 10px; }
          .vts-side-arr {
            width: 40px; height: 40px; font-size: 20px;
            background: rgba(201,168,76,.15);
            border-color: rgba(201,168,76,.3);
            color: ${C.goldLight};
          }

          .vts-queue {
            border-left: none;
            border-top: 1px solid rgba(255,255,255,.06);
            max-height: none;
          }
          .vts-queue-list {
            display: flex; flex-direction: row;
            overflow-x: auto; overflow-y: hidden;
            padding: 10px 16px 14px; gap: 10px;
            -webkit-overflow-scrolling: touch;
          }
          .vts-queue-list::-webkit-scrollbar { display: none; }
          .vts-q-item {
            flex-direction: column; align-items: center; text-align: center;
            min-width: 84px; border-left: none;
            border-bottom: 3px solid transparent;
            padding: 8px; border-radius: 12px;
          }
          .vts-q-item.active { border-bottom-color: ${C.gold}; border-left-color: transparent; }
          .vts-q-thumb { width: 50px; height: 76px; }
          .vts-q-num { display: none; }
          .vts-strip { flex-direction: column; align-items: flex-start; }
          .vts-r-sep { display: none; }
        }

        @media (max-width: 480px) {
          .vts-h { font-size: clamp(24px, 7vw, 32px); }
          .vts-reel-pane { padding: 28px 56px; }
          .vts-side-arr { width: 36px; height: 36px; font-size: 18px; }
        }
      `}</style>

      <section className="vts-sec" id="video-testimonials" ref={sectionRef}>

        {/* Header */}
        <div className="vts-header">
          <div>
            <div className="vts-eyebrow">
              <div className="vts-eyebrow-line" />
              Customer Stories
              <div className="vts-eyebrow-line" />
            </div>
            <h2 className="vts-h">
              Real People,<br /><em>Real Celebrations</em>
            </h2>
          </div>
          <div className="vts-counter">
            <span>{String(activeIdx + 1).padStart(2, "0")}</span>
            {" / " + String(TESTIMONIALS.length).padStart(2, "0")}
          </div>
        </div>

        {/* Stage */}
        <div className="vts-stage">
          <div className={`vts-transition${transitioning ? " show" : ""}`} />

          {/* Reel Pane — arrows sit left/right inside this container */}
          <div className="vts-reel-pane">
            <div className={`vts-glow-sphere${playing ? " playing-glow" : ""}`} />

            {/* ── Prev arrow — floats left of the reel ── */}
            <button className="vts-side-arr prev" onClick={goPrev} aria-label="Previous">‹</button>

            <div
              className={`vts-reel${playing ? " playing" : ""}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={handleReelClick}
            >
              <div className="vts-notch" />

              <div className="vts-prog">
                <div className="vts-prog-fill" style={{ width:`${progress}%` }} />
              </div>

              <video
                key={activeIdx}
                ref={videoRef}
                className="vts-video"
                src={cur.src}
                muted={false}
                playsInline
                preload="auto"
                onLoadedMetadata={(e) => { e.target.currentTime = 0.01; }}
              />

              {/* slim bottom gradient only — so name text stays readable */}
              <div className="vts-ovl" />

              {/* pulse ring — hidden when playing */}
              {!playing && <div className="vts-pulse-ring" />}

              {/* play button */}
              {!playing && (
                <div className="vts-play-area">
                  <button className="vts-play-btn" onClick={handlePlayBtnClick} aria-label="Play">
                    <svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                  </button>
                </div>
              )}

              {/* info — stars + name */}
              <div className="vts-reel-info" key={activeIdx}>
                <div className="vts-stars">
                  {[1,2,3,4,5].map(n => (
                    <span key={n} style={{ fontSize:13, color: n <= cur.rating ? C.gold : "rgba(201,168,76,.2)" }}>★</span>
                  ))}
                </div>
                <div className="vts-identity">
                  <div className="vts-avatar">
                    {cur.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
                  </div>
                  <div>
                    <div className="vts-name">{cur.name}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Next arrow — floats right of the reel ── */}
            <button className="vts-side-arr next" onClick={goNext} aria-label="Next">›</button>
          </div>

          {/* Queue Sidebar */}
          <div className="vts-queue">
            <div className="vts-queue-header">
              <div className="vts-queue-title">Up Next</div>
            </div>
            <div className="vts-queue-list">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={i}
                  className={`vts-q-item${i === activeIdx ? " active" : ""}`}
                  onClick={() => goTo(i)}
                >
                  <div className="vts-q-thumb">
                    <div className="vts-q-thumb-bg" />
                    <span className="vts-q-initials">
                      {t.name.split(" ").map(w => w[0]).slice(0, 2).join("")}
                    </span>
                    {i === activeIdx && playing && (
                      <div className="vts-q-eq-wrap">
                        <div className="vts-q-eq">
                          <div className="vts-q-bar" />
                          <div className="vts-q-bar" />
                          <div className="vts-q-bar" />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="vts-q-info">
                    <div className="vts-q-name">{t.name}</div>
                    <div className="vts-q-event">{t.event} · {t.loc}</div>
                  </div>
                  <div className="vts-q-num">{String(i + 1).padStart(2, "0")}</div>
                </div>
              ))}
            </div>
            <div className="vts-queue-nav">
              <span className="vts-nav-label">Navigate</span>
              <div className="vts-nav-arrows">
                <button className="vts-nav-btn" onClick={goPrev} aria-label="Previous">‹</button>
                <button className="vts-nav-btn" onClick={goNext} aria-label="Next">›</button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="vts-strip">
          <div className="vts-ratings">
            {[
              { num:"4.9★", label:"Google" },
              null,
              { num:"5★", label:"By Families" },
              null,
              { num:"5★",  label:"Rated By Couples" },
              null,
              { num:"50k+", label:"Happy Customers" },
            ].map((item, i) =>
              item === null
                ? <div key={i} className="vts-r-sep" />
                : <div key={i} className="vts-r-item">
                    <div className="vts-r-num">{item.num}</div>
                    <div className="vts-r-label">{item.label}</div>
                  </div>
            )}
          </div>
          <a href="/locations" className="vts-btn-gold">🎉 Book Your Celebration</a>
        </div>

      </section>
    </>
  );
}